/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AddMyEmailBody,
  AddMyEmailResponse,
  AddMyPhoneBody,
  AddMyPhoneResponse,
  ChatThreadContentShareCandidatesResponse,
  ChatThreadsIndexResponse,
  ClaimChatInvitationsResponse,
  CompleteSocialLoginBody,
  ContinueSocialLoginBody,
  CreateChatInvitationBody,
  CreateChatInvitationResponse,
  CreateContentResponse,
  CreateGroupBody,
  CreateGroupResponse,
  CreateInstancesBody,
  CreateTypesBody,
  DeleteContentBody,
  DeleteContentResponse,
  DeleteMyUserAccountResponse,
  DeviceMutationResponse,
  DownloadContentPdfParams,
  ErrorResponse,
  ExecuteApprovedGraphMutationBody,
  GetContentLatestResponse,
  GetContentSharingResponse,
  GetLatestParams,
  GetMyNextActionParams,
  GetSharingParams,
  GraphMutationApprovalPreviewBody,
  GraphMutationApprovalPreviewResponse,
  GraphMutationBody,
  GraphMutationResponse,
  GroupChat,
  JoinGroupResponse,
  ListContentTypesResponse,
  ListGroupMembersParams,
  ListGroupMembersResponse,
  ListMyGroupsParams,
  ListMyGroupsResponse,
  ListSubGroupsParams,
  ListSubGroupsResponse,
  ListTypesParams,
  MutateContentBody,
  MutateContentResponse,
  MyEmailsResponse,
  MyPhonesResponse,
  MyUser,
  NativeAuthFlowState,
  NativeAuthStartResponse,
  NativeAuthTokenResponse,
  NextActionResponse,
  NotificationPreferenceListResponse,
  NotificationSettingsResponse,
  NotificationTopic,
  PasswordLoginBody,
  PinnedGroupsResponse,
  RegisterDeviceBody,
  RemoveMyEmailBody,
  RemoveMyPhoneBody,
  ResendMyEmailCodeBody,
  ResendMyEmailCodeResponse,
  ResendMyPhoneCodeBody,
  ResendMyPhoneCodeResponse,
  ResendNativeLoginBody,
  ResolveChatIdentitiesBody,
  ResolveChatIdentitiesResponse,
  ResolveChatParticipantsBody,
  ResolveChatParticipantsResponse,
  ResolvePendingDmBody,
  ResolvePendingDmResponse,
  SearchContentBody,
  SearchContentResponse,
  SetPinnedGroupsBody,
  SetPrimaryEmailBody,
  SetPrimaryPhoneBody,
  ShareChatThreadContentBody,
  ShareChatThreadContentResponse,
  ShareContentBody,
  ShareContentResponse,
  StartNativeLoginBody,
  StartNativeRecoveryBody,
  StartNativeSignupBody,
  StartSocialLoginBody,
  StartSocialLoginResponse,
  UnregisterDeviceBody,
  UpdateMyUserProfileBody,
  UpdateNotificationPreferenceBody,
  UpdateNotificationSettingsBody,
  UpdateTypeBody,
  UpdateVoicePreferencesBody,
  VerifyMyEmailBody,
  VerifyMyEmailResponse,
  VerifyMyPhoneBody,
  VerifyMyPhoneResponse,
  VerifyNativeLoginBody,
  VoicePreferencesResponse,
} from './models';

import { onearlyRequest } from '../../client';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type passwordLoginResponse200 = {
  data: NativeAuthTokenResponse;
  status: 200;
};

export type passwordLoginResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type passwordLoginResponse501 = {
  data: ErrorResponse;
  status: 501;
};

export type passwordLoginResponseSuccess = passwordLoginResponse200 & {
  headers: Headers;
};
export type passwordLoginResponseError = (passwordLoginResponse400 | passwordLoginResponse501) & {
  headers: Headers;
};

export type passwordLoginResponse = passwordLoginResponseSuccess | passwordLoginResponseError;

export const getPasswordLoginUrl = () => {
  return `/api/v1/auth/login/password`;
};

/**
 * Authenticates an identity that has an Ory password credential and returns OAuth access/refresh tokens.
 * @summary Sign in with a password
 */
export const passwordLogin = async (
  passwordLoginBody: PasswordLoginBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<passwordLoginResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<passwordLoginResponse>(getPasswordLoginUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(passwordLoginBody),
  });
};

export const getPasswordLoginMutationKey = () => ['passwordLogin'] as const;

export const getPasswordLoginMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof passwordLogin>>,
    TError,
    PasswordLoginMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof passwordLogin>>,
  TError,
  PasswordLoginMutationVariables,
  TContext
> => {
  const mutationKey = getPasswordLoginMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof passwordLogin>>,
    PasswordLoginMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return passwordLogin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PasswordLoginMutationResult = NonNullable<Awaited<ReturnType<typeof passwordLogin>>>;
export type PasswordLoginMutationBody = PasswordLoginBody;
export type PasswordLoginMutationError = ErrorResponse;
export type PasswordLoginMutationVariables = { data: PasswordLoginBody };

/**
 * @summary Sign in with a password
 */
export const usePasswordLogin = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof passwordLogin>>,
      TError,
      PasswordLoginMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof passwordLogin>>,
  TError,
  PasswordLoginMutationVariables,
  TContext
> => {
  return useMutation(getPasswordLoginMutationOptions(options), queryClient);
};

export type resendNativeLoginResponse200 = {
  data: NativeAuthFlowState;
  status: 200;
};

export type resendNativeLoginResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type resendNativeLoginResponse501 = {
  data: ErrorResponse;
  status: 501;
};

export type resendNativeLoginResponseSuccess = resendNativeLoginResponse200 & {
  headers: Headers;
};
export type resendNativeLoginResponseError = (
  | resendNativeLoginResponse400
  | resendNativeLoginResponse501
) & {
  headers: Headers;
};

export type resendNativeLoginResponse =
  | resendNativeLoginResponseSuccess
  | resendNativeLoginResponseError;

export const getResendNativeLoginUrl = () => {
  return `/api/v1/auth/login/resend`;
};

/**
 * Requests a new one-time code for an in-progress native auth flow. A `homeRegion` in the body, the person's choice for an account with no home yet, stays in the returned flow state; for a new account it must be open for sign-up (`HOME_REGION_NOT_OPEN` otherwise), and for an existing one verify checks it against the signed-in identity. A request carrying `x-echo-platform` (Stronger Memory's app) takes the regions open to Stronger Memory's sign-ups.
 * @summary Resend native login code
 */
export const resendNativeLogin = async (
  resendNativeLoginBody: ResendNativeLoginBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<resendNativeLoginResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<resendNativeLoginResponse>(getResendNativeLoginUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(resendNativeLoginBody),
  });
};

export const getResendNativeLoginMutationKey = () => ['resendNativeLogin'] as const;

export const getResendNativeLoginMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendNativeLogin>>,
    TError,
    ResendNativeLoginMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendNativeLogin>>,
  TError,
  ResendNativeLoginMutationVariables,
  TContext
> => {
  const mutationKey = getResendNativeLoginMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendNativeLogin>>,
    ResendNativeLoginMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return resendNativeLogin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendNativeLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendNativeLogin>>
>;
export type ResendNativeLoginMutationBody = ResendNativeLoginBody;
export type ResendNativeLoginMutationError = ErrorResponse;
export type ResendNativeLoginMutationVariables = { data: ResendNativeLoginBody };

/**
 * @summary Resend native login code
 */
export const useResendNativeLogin = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resendNativeLogin>>,
      TError,
      ResendNativeLoginMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resendNativeLogin>>,
  TError,
  ResendNativeLoginMutationVariables,
  TContext
> => {
  return useMutation(getResendNativeLoginMutationOptions(options), queryClient);
};

export type completeSocialLoginResponse200 = {
  data: NativeAuthTokenResponse;
  status: 200;
};

export type completeSocialLoginResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type completeSocialLoginResponse501 = {
  data: ErrorResponse;
  status: 501;
};

export type completeSocialLoginResponseSuccess = completeSocialLoginResponse200 & {
  headers: Headers;
};
export type completeSocialLoginResponseError = (
  | completeSocialLoginResponse400
  | completeSocialLoginResponse501
) & {
  headers: Headers;
};

export type completeSocialLoginResponse =
  | completeSocialLoginResponseSuccess
  | completeSocialLoginResponseError;

export const getCompleteSocialLoginUrl = () => {
  return `/api/v1/auth/login/social/complete`;
};

/**
 * Exchanges the session-token exchange code from /login/social/start together with the code Ory appends to the redirect URI for OAuth access/refresh tokens. The app never talks to Ory directly. A social sign-up asks no region: where Stronger Memory's sign-ups are open in one region alone, a request that names `app: strongermemory`, or names no app and carries `x-echo-platform`, homes an account with no home yet there, and the access token carries it as `home_region`. Otherwise nothing is recorded, as before.
 * @summary Complete social login after the provider redirect
 */
export const completeSocialLogin = async (
  completeSocialLoginBody: CompleteSocialLoginBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<completeSocialLoginResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<completeSocialLoginResponse>(getCompleteSocialLoginUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(completeSocialLoginBody),
  });
};

export const getCompleteSocialLoginMutationKey = () => ['completeSocialLogin'] as const;

export const getCompleteSocialLoginMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeSocialLogin>>,
    TError,
    CompleteSocialLoginMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeSocialLogin>>,
  TError,
  CompleteSocialLoginMutationVariables,
  TContext
> => {
  const mutationKey = getCompleteSocialLoginMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeSocialLogin>>,
    CompleteSocialLoginMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return completeSocialLogin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteSocialLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeSocialLogin>>
>;
export type CompleteSocialLoginMutationBody = CompleteSocialLoginBody;
export type CompleteSocialLoginMutationError = ErrorResponse;
export type CompleteSocialLoginMutationVariables = { data: CompleteSocialLoginBody };

/**
 * @summary Complete social login after the provider redirect
 */
export const useCompleteSocialLogin = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof completeSocialLogin>>,
      TError,
      CompleteSocialLoginMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof completeSocialLogin>>,
  TError,
  CompleteSocialLoginMutationVariables,
  TContext
> => {
  return useMutation(getCompleteSocialLoginMutationOptions(options), queryClient);
};

export type continueSocialLoginResponse200 = {
  data: NativeAuthFlowState;
  status: 200;
};

export type continueSocialLoginResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type continueSocialLoginResponse501 = {
  data: ErrorResponse;
  status: 501;
};

export type continueSocialLoginResponseSuccess = continueSocialLoginResponse200 & {
  headers: Headers;
};
export type continueSocialLoginResponseError = (
  | continueSocialLoginResponse400
  | continueSocialLoginResponse501
) & {
  headers: Headers;
};

export type continueSocialLoginResponse =
  | continueSocialLoginResponseSuccess
  | continueSocialLoginResponseError;

export const getContinueSocialLoginUrl = () => {
  return `/api/v1/auth/login/social/continue`;
};

/**
 * When the provider email already belongs to an account, Ory returns a flow id instead of an authorization code. This sends that account a one-time code and returns the flow state; completing it through /login/verify signs the user in and attaches the provider. For a request carrying `x-echo-platform` (Stronger Memory's app), where Stronger Memory's sign-ups are open in one region alone, the flow state carries that region as `homeRegion`, which verify records only for an account with no home yet.
 * @summary Continue a social login that needs the existing account confirmed
 */
export const continueSocialLogin = async (
  continueSocialLoginBody: ContinueSocialLoginBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<continueSocialLoginResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<continueSocialLoginResponse>(getContinueSocialLoginUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(continueSocialLoginBody),
  });
};

export const getContinueSocialLoginMutationKey = () => ['continueSocialLogin'] as const;

export const getContinueSocialLoginMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof continueSocialLogin>>,
    TError,
    ContinueSocialLoginMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof continueSocialLogin>>,
  TError,
  ContinueSocialLoginMutationVariables,
  TContext
> => {
  const mutationKey = getContinueSocialLoginMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof continueSocialLogin>>,
    ContinueSocialLoginMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return continueSocialLogin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ContinueSocialLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof continueSocialLogin>>
>;
export type ContinueSocialLoginMutationBody = ContinueSocialLoginBody;
export type ContinueSocialLoginMutationError = ErrorResponse;
export type ContinueSocialLoginMutationVariables = { data: ContinueSocialLoginBody };

/**
 * @summary Continue a social login that needs the existing account confirmed
 */
export const useContinueSocialLogin = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof continueSocialLogin>>,
      TError,
      ContinueSocialLoginMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof continueSocialLogin>>,
  TError,
  ContinueSocialLoginMutationVariables,
  TContext
> => {
  return useMutation(getContinueSocialLoginMutationOptions(options), queryClient);
};

export type startSocialLoginResponse200 = {
  data: StartSocialLoginResponse;
  status: 200;
};

export type startSocialLoginResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type startSocialLoginResponse501 = {
  data: ErrorResponse;
  status: 501;
};

export type startSocialLoginResponseSuccess = startSocialLoginResponse200 & {
  headers: Headers;
};
export type startSocialLoginResponseError = (
  | startSocialLoginResponse400
  | startSocialLoginResponse501
) & {
  headers: Headers;
};

export type startSocialLoginResponse =
  | startSocialLoginResponseSuccess
  | startSocialLoginResponseError;

export const getStartSocialLoginUrl = () => {
  return `/api/v1/auth/login/social/start`;
};

/**
 * Returns the public OAuth authorize URL the client browser must open. Ory session cookies must be established in the user browser during the Hydra redirect chain; do not open upstream Google/Apple URLs returned from a server-side OIDC submit.
 * @summary Start social OAuth login
 */
export const startSocialLogin = async (
  startSocialLoginBody: StartSocialLoginBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<startSocialLoginResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<startSocialLoginResponse>(getStartSocialLoginUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(startSocialLoginBody),
  });
};

export const getStartSocialLoginMutationKey = () => ['startSocialLogin'] as const;

export const getStartSocialLoginMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startSocialLogin>>,
    TError,
    StartSocialLoginMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startSocialLogin>>,
  TError,
  StartSocialLoginMutationVariables,
  TContext
> => {
  const mutationKey = getStartSocialLoginMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startSocialLogin>>,
    StartSocialLoginMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return startSocialLogin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartSocialLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof startSocialLogin>>
>;
export type StartSocialLoginMutationBody = StartSocialLoginBody;
export type StartSocialLoginMutationError = ErrorResponse;
export type StartSocialLoginMutationVariables = { data: StartSocialLoginBody };

/**
 * @summary Start social OAuth login
 */
export const useStartSocialLogin = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof startSocialLogin>>,
      TError,
      StartSocialLoginMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof startSocialLogin>>,
  TError,
  StartSocialLoginMutationVariables,
  TContext
> => {
  return useMutation(getStartSocialLoginMutationOptions(options), queryClient);
};

export type startNativeLoginResponse200 = {
  data: NativeAuthStartResponse;
  status: 200;
};

export type startNativeLoginResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type startNativeLoginResponse501 = {
  data: ErrorResponse;
  status: 501;
};

export type startNativeLoginResponseSuccess = startNativeLoginResponse200 & {
  headers: Headers;
};
export type startNativeLoginResponseError = (
  | startNativeLoginResponse400
  | startNativeLoginResponse501
) & {
  headers: Headers;
};

export type startNativeLoginResponse =
  | startNativeLoginResponseSuccess
  | startNativeLoginResponseError;

export const getStartNativeLoginUrl = () => {
  return `/api/v1/auth/login/start`;
};

/**
 * Creates an Ory Kratos native flow and sends a one-time code to the supplied email or phone. Returns flow state the client must send back to /login/verify, and whether the account has no home region yet (`homeRegionRequired`), in which case the client asks the person, even when only one region is open, and sends their choice as `homeRegion` on verify. A `homeRegion` sent here is only the device's default: kept in the flow state if it is open for sign-up, dropped if not. A request carrying `x-echo-platform` (Stronger Memory's app) takes the regions open to Stronger Memory's sign-ups, and where they are one region, that region is the default.
 * @summary Start native login or registration
 */
export const startNativeLogin = async (
  startNativeLoginBody: StartNativeLoginBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<startNativeLoginResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<startNativeLoginResponse>(getStartNativeLoginUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(startNativeLoginBody),
  });
};

export const getStartNativeLoginMutationKey = () => ['startNativeLogin'] as const;

export const getStartNativeLoginMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startNativeLogin>>,
    TError,
    StartNativeLoginMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startNativeLogin>>,
  TError,
  StartNativeLoginMutationVariables,
  TContext
> => {
  const mutationKey = getStartNativeLoginMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startNativeLogin>>,
    StartNativeLoginMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return startNativeLogin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartNativeLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof startNativeLogin>>
>;
export type StartNativeLoginMutationBody = StartNativeLoginBody;
export type StartNativeLoginMutationError = ErrorResponse;
export type StartNativeLoginMutationVariables = { data: StartNativeLoginBody };

/**
 * @summary Start native login or registration
 */
export const useStartNativeLogin = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof startNativeLogin>>,
      TError,
      StartNativeLoginMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof startNativeLogin>>,
  TError,
  StartNativeLoginMutationVariables,
  TContext
> => {
  return useMutation(getStartNativeLoginMutationOptions(options), queryClient);
};

export type verifyNativeLoginResponse200 = {
  data: NativeAuthTokenResponse;
  status: 200;
};

export type verifyNativeLoginResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type verifyNativeLoginResponse501 = {
  data: ErrorResponse;
  status: 501;
};

export type verifyNativeLoginResponseSuccess = verifyNativeLoginResponse200 & {
  headers: Headers;
};
export type verifyNativeLoginResponseError = (
  | verifyNativeLoginResponse400
  | verifyNativeLoginResponse501
) & {
  headers: Headers;
};

export type verifyNativeLoginResponse =
  | verifyNativeLoginResponseSuccess
  | verifyNativeLoginResponseError;

export const getVerifyNativeLoginUrl = () => {
  return `/api/v1/auth/login/verify`;
};

/**
 * Completes the Ory native flow with the one-time code and returns OAuth access/refresh tokens. If the account has no home region yet and the body carries `homeRegion`, the person's choice, it must be open for sign-up, or the answer is `HOME_REGION_NOT_OPEN`: for a new account before the code is spent, for an existing one once the code verifies, since only the signed-in identity says whose account it is. The choice is recorded, and the access token carries it as `home_region`. An account that already has a home keeps it, and a `homeRegion` sent for it is ignored. The regions open are Stronger Memory's for a request that names `app: strongermemory`, or names no app and carries `x-echo-platform`; where they are one region, a new account that sends no `homeRegion` is homed there.
 * @summary Verify native login code
 */
export const verifyNativeLogin = async (
  verifyNativeLoginBody: VerifyNativeLoginBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<verifyNativeLoginResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<verifyNativeLoginResponse>(getVerifyNativeLoginUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(verifyNativeLoginBody),
  });
};

export const getVerifyNativeLoginMutationKey = () => ['verifyNativeLogin'] as const;

export const getVerifyNativeLoginMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyNativeLogin>>,
    TError,
    VerifyNativeLoginMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyNativeLogin>>,
  TError,
  VerifyNativeLoginMutationVariables,
  TContext
> => {
  const mutationKey = getVerifyNativeLoginMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyNativeLogin>>,
    VerifyNativeLoginMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return verifyNativeLogin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyNativeLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyNativeLogin>>
>;
export type VerifyNativeLoginMutationBody = VerifyNativeLoginBody;
export type VerifyNativeLoginMutationError = ErrorResponse;
export type VerifyNativeLoginMutationVariables = { data: VerifyNativeLoginBody };

/**
 * @summary Verify native login code
 */
export const useVerifyNativeLogin = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof verifyNativeLogin>>,
      TError,
      VerifyNativeLoginMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof verifyNativeLogin>>,
  TError,
  VerifyNativeLoginMutationVariables,
  TContext
> => {
  return useMutation(getVerifyNativeLoginMutationOptions(options), queryClient);
};

export type startNativeRecoveryResponse200 = {
  data: NativeAuthFlowState;
  status: 200;
};

export type startNativeRecoveryResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type startNativeRecoveryResponse501 = {
  data: ErrorResponse;
  status: 501;
};

export type startNativeRecoveryResponseSuccess = startNativeRecoveryResponse200 & {
  headers: Headers;
};
export type startNativeRecoveryResponseError = (
  | startNativeRecoveryResponse400
  | startNativeRecoveryResponse501
) & {
  headers: Headers;
};

export type startNativeRecoveryResponse =
  | startNativeRecoveryResponseSuccess
  | startNativeRecoveryResponseError;

export const getStartNativeRecoveryUrl = () => {
  return `/api/v1/auth/recovery/start`;
};

/**
 * Creates an Ory Kratos native recovery flow for an existing account and sends a one-time code to the supplied email or phone. Complete it through /login/verify (the returned flow has kind "recovery"), which logs the user in.
 * @summary Start account recovery
 */
export const startNativeRecovery = async (
  startNativeRecoveryBody: StartNativeRecoveryBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<startNativeRecoveryResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<startNativeRecoveryResponse>(getStartNativeRecoveryUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(startNativeRecoveryBody),
  });
};

export const getStartNativeRecoveryMutationKey = () => ['startNativeRecovery'] as const;

export const getStartNativeRecoveryMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startNativeRecovery>>,
    TError,
    StartNativeRecoveryMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startNativeRecovery>>,
  TError,
  StartNativeRecoveryMutationVariables,
  TContext
> => {
  const mutationKey = getStartNativeRecoveryMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startNativeRecovery>>,
    StartNativeRecoveryMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return startNativeRecovery(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartNativeRecoveryMutationResult = NonNullable<
  Awaited<ReturnType<typeof startNativeRecovery>>
>;
export type StartNativeRecoveryMutationBody = StartNativeRecoveryBody;
export type StartNativeRecoveryMutationError = ErrorResponse;
export type StartNativeRecoveryMutationVariables = { data: StartNativeRecoveryBody };

/**
 * @summary Start account recovery
 */
export const useStartNativeRecovery = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof startNativeRecovery>>,
      TError,
      StartNativeRecoveryMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof startNativeRecovery>>,
  TError,
  StartNativeRecoveryMutationVariables,
  TContext
> => {
  return useMutation(getStartNativeRecoveryMutationOptions(options), queryClient);
};

export type startNativeSignupResponse200 = {
  data: NativeAuthStartResponse;
  status: 200;
};

export type startNativeSignupResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type startNativeSignupResponse409 = {
  data: ErrorResponse;
  status: 409;
};

export type startNativeSignupResponse501 = {
  data: ErrorResponse;
  status: 501;
};

export type startNativeSignupResponseSuccess = startNativeSignupResponse200 & {
  headers: Headers;
};
export type startNativeSignupResponseError = (
  | startNativeSignupResponse400
  | startNativeSignupResponse409
  | startNativeSignupResponse501
) & {
  headers: Headers;
};

export type startNativeSignupResponse =
  | startNativeSignupResponseSuccess
  | startNativeSignupResponseError;

export const getStartNativeSignupUrl = () => {
  return `/api/v1/auth/signup/start`;
};

/**
 * Creates an Ory Kratos native registration flow with email, phone, and name traits, then sends a one-time verification code. A new account has no home region yet, so `homeRegionRequired` is true and the client sends the person's choice as `homeRegion` on verify. A `homeRegion` sent here is only a default, kept if it is open for sign-up. A request carrying `x-echo-platform` (Stronger Memory's app) takes the regions open to Stronger Memory's sign-ups, and where they are one region, that region is the default.
 * @summary Start native registration
 */
export const startNativeSignup = async (
  startNativeSignupBody: StartNativeSignupBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<startNativeSignupResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<startNativeSignupResponse>(getStartNativeSignupUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(startNativeSignupBody),
  });
};

export const getStartNativeSignupMutationKey = () => ['startNativeSignup'] as const;

export const getStartNativeSignupMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startNativeSignup>>,
    TError,
    StartNativeSignupMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startNativeSignup>>,
  TError,
  StartNativeSignupMutationVariables,
  TContext
> => {
  const mutationKey = getStartNativeSignupMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startNativeSignup>>,
    StartNativeSignupMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return startNativeSignup(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartNativeSignupMutationResult = NonNullable<
  Awaited<ReturnType<typeof startNativeSignup>>
>;
export type StartNativeSignupMutationBody = StartNativeSignupBody;
export type StartNativeSignupMutationError = ErrorResponse;
export type StartNativeSignupMutationVariables = { data: StartNativeSignupBody };

/**
 * @summary Start native registration
 */
export const useStartNativeSignup = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof startNativeSignup>>,
      TError,
      StartNativeSignupMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof startNativeSignup>>,
  TError,
  StartNativeSignupMutationVariables,
  TContext
> => {
  return useMutation(getStartNativeSignupMutationOptions(options), queryClient);
};

export type resolvePendingDmResponse200 = {
  data: ResolvePendingDmResponse;
  status: 200;
};

export type resolvePendingDmResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type resolvePendingDmResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type resolvePendingDmResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type resolvePendingDmResponseSuccess = resolvePendingDmResponse200 & {
  headers: Headers;
};
export type resolvePendingDmResponseError = (
  | resolvePendingDmResponse400
  | resolvePendingDmResponse401
  | resolvePendingDmResponse403
) & {
  headers: Headers;
};

export type resolvePendingDmResponse =
  | resolvePendingDmResponseSuccess
  | resolvePendingDmResponseError;

export const getResolvePendingDmUrl = () => {
  return `/api/v1/chat/identities/pending-dm`;
};

/**
 * The identifier-branch companion to `identities/resolve` (which resolves already-mapped actors). When the caller composes to an email or phone they have already invited, this returns the SAME solo thread their open invitation sits on, so the App re-opens it instead of minting a second. The identifier is normalized identically to invitation issuance. Sender-scoped: it only ever reveals the caller's own open invitations, so it is no relationship oracle and needs no purpose-built rate limit. A null match means proceed to open a new thread and issue an invitation.
 * @summary Find the caller's open pending DM thread for an identifier
 */
export const resolvePendingDm = async (
  resolvePendingDmBody: ResolvePendingDmBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<resolvePendingDmResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<resolvePendingDmResponse>(getResolvePendingDmUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(resolvePendingDmBody),
  });
};

export const getResolvePendingDmMutationKey = () => ['resolvePendingDm'] as const;

export const getResolvePendingDmMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolvePendingDm>>,
    TError,
    ResolvePendingDmMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resolvePendingDm>>,
  TError,
  ResolvePendingDmMutationVariables,
  TContext
> => {
  const mutationKey = getResolvePendingDmMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resolvePendingDm>>,
    ResolvePendingDmMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return resolvePendingDm(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResolvePendingDmMutationResult = NonNullable<
  Awaited<ReturnType<typeof resolvePendingDm>>
>;
export type ResolvePendingDmMutationBody = ResolvePendingDmBody;
export type ResolvePendingDmMutationError = ErrorResponse;
export type ResolvePendingDmMutationVariables = { data: ResolvePendingDmBody };

/**
 * @summary Find the caller's open pending DM thread for an identifier
 */
export const useResolvePendingDm = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resolvePendingDm>>,
      TError,
      ResolvePendingDmMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resolvePendingDm>>,
  TError,
  ResolvePendingDmMutationVariables,
  TContext
> => {
  return useMutation(getResolvePendingDmMutationOptions(options), queryClient);
};

export type resolveIdentitiesResponse200 = {
  data: ResolveChatIdentitiesResponse;
  status: 200;
};

export type resolveIdentitiesResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type resolveIdentitiesResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type resolveIdentitiesResponseSuccess = resolveIdentitiesResponse200 & {
  headers: Headers;
};
export type resolveIdentitiesResponseError = (
  | resolveIdentitiesResponse401
  | resolveIdentitiesResponse403
) & {
  headers: Headers;
};

export type resolveIdentitiesResponse =
  | resolveIdentitiesResponseSuccess
  | resolveIdentitiesResponseError;

export const getResolveIdentitiesUrl = () => {
  return `/api/v1/chat/identities/resolve`;
};

/**
 * Returns the Reach user id for each requested actor the caller may see: themselves, group-mates in groups where the caller holds `view-group-members`, and groups where the caller holds a group-admin capability. Targets that are invisible, unknown, or not yet mapped to a Reach user are simply absent from the result — one shape, no probing. Side effect: ensures the caller's own actor↔Reach mapping so threads they create are attributable.
 * @summary Resolve visible OE actors to Reach user ids
 */
export const resolveIdentities = async (
  resolveChatIdentitiesBody: ResolveChatIdentitiesBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<resolveIdentitiesResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<resolveIdentitiesResponse>(getResolveIdentitiesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(resolveChatIdentitiesBody),
  });
};

export const getResolveIdentitiesMutationKey = () => ['resolveIdentities'] as const;

export const getResolveIdentitiesMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolveIdentities>>,
    TError,
    ResolveIdentitiesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resolveIdentities>>,
  TError,
  ResolveIdentitiesMutationVariables,
  TContext
> => {
  const mutationKey = getResolveIdentitiesMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resolveIdentities>>,
    ResolveIdentitiesMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return resolveIdentities(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResolveIdentitiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof resolveIdentities>>
>;
export type ResolveIdentitiesMutationBody = ResolveChatIdentitiesBody;
export type ResolveIdentitiesMutationError = ErrorResponse;
export type ResolveIdentitiesMutationVariables = { data: ResolveChatIdentitiesBody };

/**
 * @summary Resolve visible OE actors to Reach user ids
 */
export const useResolveIdentities = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resolveIdentities>>,
      TError,
      ResolveIdentitiesMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resolveIdentities>>,
  TError,
  ResolveIdentitiesMutationVariables,
  TContext
> => {
  return useMutation(getResolveIdentitiesMutationOptions(options), queryClient);
};

export type claimInvitationsResponse200 = {
  data: ClaimChatInvitationsResponse;
  status: 200;
};

export type claimInvitationsResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type claimInvitationsResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type claimInvitationsResponseSuccess = claimInvitationsResponse200 & {
  headers: Headers;
};
export type claimInvitationsResponseError = (
  | claimInvitationsResponse401
  | claimInvitationsResponse403
) & {
  headers: Headers;
};

export type claimInvitationsResponse =
  | claimInvitationsResponseSuccess
  | claimInvitationsResponseError;

export const getClaimInvitationsUrl = () => {
  return `/api/v1/chat/invitations/claim`;
};

/**
 * Call on every chat-session establishment, after the Reach SDK has authenticated (the caller's Reach user must exist). Ensures the caller's actor↔Reach mapping, then claims every open invitation whose identifier is one of the caller's VERIFIED addresses or whose target is the caller's own actor. Idempotent and cheap; the background sweep covers anyone who never calls it.
 * @summary Claim every invitation that now belongs to the caller (the nudge)
 */
export const claimInvitations = async (
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<claimInvitationsResponse> => {
  return onearlyRequest<claimInvitationsResponse>(getClaimInvitationsUrl(), {
    ...options,
    method: 'POST',
  });
};

export const getClaimInvitationsMutationKey = () => ['claimInvitations'] as const;

export const getClaimInvitationsMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof claimInvitations>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<Awaited<ReturnType<typeof claimInvitations>>, TError, void, TContext> => {
  const mutationKey = getClaimInvitationsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof claimInvitations>>, void> = () => {
    return claimInvitations(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClaimInvitationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof claimInvitations>>
>;

export type ClaimInvitationsMutationError = ErrorResponse;

/**
 * @summary Claim every invitation that now belongs to the caller (the nudge)
 */
export const useClaimInvitations = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof claimInvitations>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof claimInvitations>>, TError, void, TContext> => {
  return useMutation(getClaimInvitationsMutationOptions(options), queryClient);
};

export type resolveParticipantsResponse200 = {
  data: ResolveChatParticipantsResponse;
  status: 200;
};

export type resolveParticipantsResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type resolveParticipantsResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type resolveParticipantsResponse429 = {
  data: ErrorResponse;
  status: 429;
};

export type resolveParticipantsResponseSuccess = resolveParticipantsResponse200 & {
  headers: Headers;
};
export type resolveParticipantsResponseError = (
  | resolveParticipantsResponse401
  | resolveParticipantsResponse403
  | resolveParticipantsResponse429
) & {
  headers: Headers;
};

export type resolveParticipantsResponse =
  | resolveParticipantsResponseSuccess
  | resolveParticipantsResponseError;

export const getResolveParticipantsUrl = () => {
  return `/api/v1/chat/participants/resolve`;
};

/**
 * The identity half of a thread roster: Reach says who is in the thread; this says what to call them. Each `reachUserId` resolves only when the caller is a live member of a thread they were ever in — authorship outlives membership — or may see them under the identity-resolve visibility arms; each `invitationId` resolves only for a live member of that invitation's thread or its creator. Everything else is silently absent. The full identifier shows only to the invitation's creator; others see a masked form. Rate limited per caller.
 * @summary Name thread participants and describe pending invitations
 */
export const resolveParticipants = async (
  resolveChatParticipantsBody: ResolveChatParticipantsBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<resolveParticipantsResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<resolveParticipantsResponse>(getResolveParticipantsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(resolveChatParticipantsBody),
  });
};

export const getResolveParticipantsMutationKey = () => ['resolveParticipants'] as const;

export const getResolveParticipantsMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolveParticipants>>,
    TError,
    ResolveParticipantsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resolveParticipants>>,
  TError,
  ResolveParticipantsMutationVariables,
  TContext
> => {
  const mutationKey = getResolveParticipantsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resolveParticipants>>,
    ResolveParticipantsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return resolveParticipants(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResolveParticipantsMutationResult = NonNullable<
  Awaited<ReturnType<typeof resolveParticipants>>
>;
export type ResolveParticipantsMutationBody = ResolveChatParticipantsBody;
export type ResolveParticipantsMutationError = ErrorResponse;
export type ResolveParticipantsMutationVariables = { data: ResolveChatParticipantsBody };

/**
 * @summary Name thread participants and describe pending invitations
 */
export const useResolveParticipants = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resolveParticipants>>,
      TError,
      ResolveParticipantsMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resolveParticipants>>,
  TError,
  ResolveParticipantsMutationVariables,
  TContext
> => {
  return useMutation(getResolveParticipantsMutationOptions(options), queryClient);
};

export type listThreadRostersResponse200 = {
  data: ChatThreadsIndexResponse;
  status: 200;
};

export type listThreadRostersResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type listThreadRostersResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type listThreadRostersResponseSuccess = listThreadRostersResponse200 & {
  headers: Headers;
};
export type listThreadRostersResponseError = (
  | listThreadRostersResponse401
  | listThreadRostersResponse403
) & {
  headers: Headers;
};

export type listThreadRostersResponse =
  | listThreadRostersResponseSuccess
  | listThreadRostersResponseError;

export const getListThreadRostersUrl = () => {
  return `/api/v1/chat/threads/index`;
};

/**
 * For every thread the caller is a live member of: the live roster (member ids, types, roles — the caller included) and the ids of open Core invitations, in one round trip, from the projected roster. Ids only: batch them into `POST /participants/resolve` for names and masked invitation displays. Invitation-id visibility follows the resolve gate that already ships — any live member of a thread may see that thread's open invitations. `identityKeyed` is null until the projection carries the dm flag. Projection-backed and seconds-stale under mirror lag; SDK events keep open threads live.
 * @summary Roster index for the caller's conversation list
 */
export const listThreadRosters = async (
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<listThreadRostersResponse> => {
  return onearlyRequest<listThreadRostersResponse>(getListThreadRostersUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getListThreadRostersQueryKey = () => {
  return [`/api/v1/chat/threads/index`] as const;
};

export const getListThreadRostersQueryOptions = <
  TData = Awaited<ReturnType<typeof listThreadRosters>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listThreadRosters>>, TError, TData>>;
  request?: SecondParameter<typeof onearlyRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListThreadRostersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listThreadRosters>>> = ({ signal }) =>
    listThreadRosters({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listThreadRosters>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListThreadRostersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listThreadRosters>>
>;
export type ListThreadRostersQueryError = ErrorResponse;

export function useListThreadRosters<
  TData = Awaited<ReturnType<typeof listThreadRosters>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listThreadRosters>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listThreadRosters>>,
          TError,
          Awaited<ReturnType<typeof listThreadRosters>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListThreadRosters<
  TData = Awaited<ReturnType<typeof listThreadRosters>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listThreadRosters>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listThreadRosters>>,
          TError,
          Awaited<ReturnType<typeof listThreadRosters>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListThreadRosters<
  TData = Awaited<ReturnType<typeof listThreadRosters>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listThreadRosters>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Roster index for the caller's conversation list
 */

export function useListThreadRosters<
  TData = Awaited<ReturnType<typeof listThreadRosters>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listThreadRosters>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListThreadRostersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type shareThreadContentResponse200 = {
  data: ShareChatThreadContentResponse;
  status: 200;
};

export type shareThreadContentResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type shareThreadContentResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type shareThreadContentResponseSuccess = shareThreadContentResponse200 & {
  headers: Headers;
};
export type shareThreadContentResponseError = (
  | shareThreadContentResponse401
  | shareThreadContentResponse403
) & {
  headers: Headers;
};

export type shareThreadContentResponse =
  | shareThreadContentResponseSuccess
  | shareThreadContentResponseError;

export const getShareThreadContentUrl = (reachThreadId: string, contentUuid: string) => {
  return `/api/v1/chat/threads/${reachThreadId}/content/${contentUuid}/share`;
};

/**
 * Shares the content, with its descendants, to every current share candidate (see share-candidates) as the caller. Recipients are notified. Shares with no one unless the caller is a live member of the thread and holds SHARE on the content.
 * @summary Share mentioned content with members who can't read it
 */
export const shareThreadContent = async (
  reachThreadId: string,
  contentUuid: string,
  shareChatThreadContentBody: ShareChatThreadContentBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<shareThreadContentResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<shareThreadContentResponse>(
    getShareThreadContentUrl(reachThreadId, contentUuid),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
      body: JSON.stringify(shareChatThreadContentBody),
    },
  );
};

export const getShareThreadContentMutationKey = () => ['shareThreadContent'] as const;

export const getShareThreadContentMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof shareThreadContent>>,
    TError,
    ShareThreadContentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof shareThreadContent>>,
  TError,
  ShareThreadContentMutationVariables,
  TContext
> => {
  const mutationKey = getShareThreadContentMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof shareThreadContent>>,
    ShareThreadContentMutationVariables
  > = (props) => {
    const { reachThreadId, contentUuid, data } = props ?? {};

    return shareThreadContent(reachThreadId, contentUuid, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ShareThreadContentMutationResult = NonNullable<
  Awaited<ReturnType<typeof shareThreadContent>>
>;
export type ShareThreadContentMutationBody = ShareChatThreadContentBody;
export type ShareThreadContentMutationError = ErrorResponse;
export type ShareThreadContentMutationVariables = {
  reachThreadId: string;
  contentUuid: string;
  data: ShareChatThreadContentBody;
};

/**
 * @summary Share mentioned content with members who can't read it
 */
export const useShareThreadContent = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof shareThreadContent>>,
      TError,
      ShareThreadContentMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof shareThreadContent>>,
  TError,
  ShareThreadContentMutationVariables,
  TContext
> => {
  return useMutation(getShareThreadContentMutationOptions(options), queryClient);
};

export type listThreadContentShareCandidatesResponse200 = {
  data: ChatThreadContentShareCandidatesResponse;
  status: 200;
};

export type listThreadContentShareCandidatesResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type listThreadContentShareCandidatesResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type listThreadContentShareCandidatesResponseSuccess =
  listThreadContentShareCandidatesResponse200 & {
    headers: Headers;
  };
export type listThreadContentShareCandidatesResponseError = (
  | listThreadContentShareCandidatesResponse401
  | listThreadContentShareCandidatesResponse403
) & {
  headers: Headers;
};

export type listThreadContentShareCandidatesResponse =
  | listThreadContentShareCandidatesResponseSuccess
  | listThreadContentShareCandidatesResponseError;

export const getListThreadContentShareCandidatesUrl = (
  reachThreadId: string,
  contentUuid: string,
) => {
  return `/api/v1/chat/threads/${reachThreadId}/content/${contentUuid}/share-candidates`;
};

/**
 * The thread's live users, the caller excluded, who cannot read the content, as Reach user ids, plus the permissions the caller may grant them. Empty unless the caller is a live member of the thread and holds SHARE on the content.
 * @summary Thread members who can't read mentioned content
 */
export const listThreadContentShareCandidates = async (
  reachThreadId: string,
  contentUuid: string,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<listThreadContentShareCandidatesResponse> => {
  return onearlyRequest<listThreadContentShareCandidatesResponse>(
    getListThreadContentShareCandidatesUrl(reachThreadId, contentUuid),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getListThreadContentShareCandidatesQueryKey = (
  reachThreadId: string,
  contentUuid: string,
) => {
  return [`/api/v1/chat/threads/${reachThreadId}/content/${contentUuid}/share-candidates`] as const;
};

export const getListThreadContentShareCandidatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listThreadContentShareCandidates>>,
  TError = ErrorResponse,
>(
  reachThreadId: string,
  contentUuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listThreadContentShareCandidates>>, TError, TData>
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListThreadContentShareCandidatesQueryKey(reachThreadId, contentUuid);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listThreadContentShareCandidates>>> = ({
    signal,
  }) => listThreadContentShareCandidates(reachThreadId, contentUuid, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      reachThreadId !== null &&
      reachThreadId !== undefined &&
      contentUuid !== null &&
      contentUuid !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listThreadContentShareCandidates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListThreadContentShareCandidatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listThreadContentShareCandidates>>
>;
export type ListThreadContentShareCandidatesQueryError = ErrorResponse;

export function useListThreadContentShareCandidates<
  TData = Awaited<ReturnType<typeof listThreadContentShareCandidates>>,
  TError = ErrorResponse,
>(
  reachThreadId: string,
  contentUuid: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listThreadContentShareCandidates>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listThreadContentShareCandidates>>,
          TError,
          Awaited<ReturnType<typeof listThreadContentShareCandidates>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListThreadContentShareCandidates<
  TData = Awaited<ReturnType<typeof listThreadContentShareCandidates>>,
  TError = ErrorResponse,
>(
  reachThreadId: string,
  contentUuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listThreadContentShareCandidates>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listThreadContentShareCandidates>>,
          TError,
          Awaited<ReturnType<typeof listThreadContentShareCandidates>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListThreadContentShareCandidates<
  TData = Awaited<ReturnType<typeof listThreadContentShareCandidates>>,
  TError = ErrorResponse,
>(
  reachThreadId: string,
  contentUuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listThreadContentShareCandidates>>, TError, TData>
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Thread members who can't read mentioned content
 */

export function useListThreadContentShareCandidates<
  TData = Awaited<ReturnType<typeof listThreadContentShareCandidates>>,
  TError = ErrorResponse,
>(
  reachThreadId: string,
  contentUuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listThreadContentShareCandidates>>, TError, TData>
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListThreadContentShareCandidatesQueryOptions(
    reachThreadId,
    contentUuid,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createChatInvitationResponse202 = {
  data: CreateChatInvitationResponse;
  status: 202;
};

export type createChatInvitationResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type createChatInvitationResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type createChatInvitationResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type createChatInvitationResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type createChatInvitationResponse409 = {
  data: ErrorResponse;
  status: 409;
};

export type createChatInvitationResponse429 = {
  data: ErrorResponse;
  status: 429;
};

export type createChatInvitationResponseSuccess = createChatInvitationResponse202 & {
  headers: Headers;
};
export type createChatInvitationResponseError = (
  | createChatInvitationResponse400
  | createChatInvitationResponse401
  | createChatInvitationResponse403
  | createChatInvitationResponse404
  | createChatInvitationResponse409
  | createChatInvitationResponse429
) & {
  headers: Headers;
};

export type createChatInvitationResponse =
  | createChatInvitationResponseSuccess
  | createChatInvitationResponseError;

export const getCreateChatInvitationUrl = (reachThreadId: string) => {
  return `/api/v1/chat/threads/${reachThreadId}/invitations`;
};

/**
 * Reserves a place on the thread for someone Reach cannot name yet. Exactly one of `identifier` (email or E.164 phone the caller already holds) or `targetActorUuid` (a visible OE user who has never opened chat). The response is byte-identical whether or not an account exists behind an identifier, identifier invitations expire in 7 days (actor invitations in 180), and identifier issuance is capped per sender per 24h. Core notifies the target minimally and claims the reservation automatically when the person's chat session exists; re-inviting after expiry is one tap and re-notifies.
 * @summary Invite a person to a Reach thread by identifier or OE actor
 */
export const createChatInvitation = async (
  reachThreadId: string,
  createChatInvitationBody: CreateChatInvitationBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<createChatInvitationResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<createChatInvitationResponse>(getCreateChatInvitationUrl(reachThreadId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createChatInvitationBody),
  });
};

export const getCreateChatInvitationMutationKey = () => ['createChatInvitation'] as const;

export const getCreateChatInvitationMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createChatInvitation>>,
    TError,
    CreateChatInvitationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createChatInvitation>>,
  TError,
  CreateChatInvitationMutationVariables,
  TContext
> => {
  const mutationKey = getCreateChatInvitationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createChatInvitation>>,
    CreateChatInvitationMutationVariables
  > = (props) => {
    const { reachThreadId, data } = props ?? {};

    return createChatInvitation(reachThreadId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateChatInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createChatInvitation>>
>;
export type CreateChatInvitationMutationBody = CreateChatInvitationBody;
export type CreateChatInvitationMutationError = ErrorResponse;
export type CreateChatInvitationMutationVariables = {
  reachThreadId: string;
  data: CreateChatInvitationBody;
};

/**
 * @summary Invite a person to a Reach thread by identifier or OE actor
 */
export const useCreateChatInvitation = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createChatInvitation>>,
      TError,
      CreateChatInvitationMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createChatInvitation>>,
  TError,
  CreateChatInvitationMutationVariables,
  TContext
> => {
  return useMutation(getCreateChatInvitationMutationOptions(options), queryClient);
};

export type withdrawChatInvitationResponse204 = {
  data: void;
  status: 204;
};

export type withdrawChatInvitationResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type withdrawChatInvitationResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type withdrawChatInvitationResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type withdrawChatInvitationResponse409 = {
  data: ErrorResponse;
  status: 409;
};

export type withdrawChatInvitationResponseSuccess = withdrawChatInvitationResponse204 & {
  headers: Headers;
};
export type withdrawChatInvitationResponseError = (
  | withdrawChatInvitationResponse401
  | withdrawChatInvitationResponse403
  | withdrawChatInvitationResponse404
  | withdrawChatInvitationResponse409
) & {
  headers: Headers;
};

export type withdrawChatInvitationResponse =
  | withdrawChatInvitationResponseSuccess
  | withdrawChatInvitationResponseError;

export const getWithdrawChatInvitationUrl = (reachThreadId: string, invitationUuid: string) => {
  return `/api/v1/chat/threads/${reachThreadId}/invitations/${invitationUuid}`;
};

/**
 * Revokes the Reach reservation and settles the ledger; notifications stop. Allowed for the invitation's creator, or for a live thread owner (enforced by Reach's broker arm). Withdrawing an already-withdrawn or expired invitation is a no-op success; a claimed invitation cannot be withdrawn.
 * @summary Withdraw an open chat invitation
 */
export const withdrawChatInvitation = async (
  reachThreadId: string,
  invitationUuid: string,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<withdrawChatInvitationResponse> => {
  return onearlyRequest<withdrawChatInvitationResponse>(
    getWithdrawChatInvitationUrl(reachThreadId, invitationUuid),
    {
      ...options,
      method: 'DELETE',
    },
  );
};

export const getWithdrawChatInvitationMutationKey = () => ['withdrawChatInvitation'] as const;

export const getWithdrawChatInvitationMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof withdrawChatInvitation>>,
    TError,
    WithdrawChatInvitationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof withdrawChatInvitation>>,
  TError,
  WithdrawChatInvitationMutationVariables,
  TContext
> => {
  const mutationKey = getWithdrawChatInvitationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof withdrawChatInvitation>>,
    WithdrawChatInvitationMutationVariables
  > = (props) => {
    const { reachThreadId, invitationUuid } = props ?? {};

    return withdrawChatInvitation(reachThreadId, invitationUuid, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WithdrawChatInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof withdrawChatInvitation>>
>;

export type WithdrawChatInvitationMutationError = ErrorResponse;
export type WithdrawChatInvitationMutationVariables = {
  reachThreadId: string;
  invitationUuid: string;
};

/**
 * @summary Withdraw an open chat invitation
 */
export const useWithdrawChatInvitation = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof withdrawChatInvitation>>,
      TError,
      WithdrawChatInvitationMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof withdrawChatInvitation>>,
  TError,
  WithdrawChatInvitationMutationVariables,
  TContext
> => {
  return useMutation(getWithdrawChatInvitationMutationOptions(options), queryClient);
};

export type contentDeleteResponse200 = {
  data: DeleteContentResponse;
  status: 200;
};

export type contentDeleteResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type contentDeleteResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type contentDeleteResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type contentDeleteResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type contentDeleteResponse409 = {
  data: ErrorResponse;
  status: 409;
};

export type contentDeleteResponseSuccess = contentDeleteResponse200 & {
  headers: Headers;
};
export type contentDeleteResponseError = (
  | contentDeleteResponse400
  | contentDeleteResponse401
  | contentDeleteResponse403
  | contentDeleteResponse404
  | contentDeleteResponse409
) & {
  headers: Headers;
};

export type contentDeleteResponse = contentDeleteResponseSuccess | contentDeleteResponseError;

export const getContentDeleteUrl = () => {
  return `/api/v1/content/delete`;
};

/**
 * Deletes each lineage in `lineageUuids` — its current head and everything it CONTAINS — as ONE all-or-nothing transaction, and returns what was removed. Works for TYPE and INSTANCE content alike: a deleted TYPE leaves catalogues, while instances that already point at it keep resolving it. Requires DELETE permission on every node the cascade would remove.
 *
 * `idempotencyKey` is required: the same key with the same lineages replays the stored acknowledgement (`replayed: true`) without deleting again, and the same key with different lineages is a 409. The receipt is shared with GraphQL `deleteContent`, which is the same operation.
 * @summary Delete content lineages and everything they contain
 */
export const contentDelete = async (
  deleteContentBody: DeleteContentBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<contentDeleteResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<contentDeleteResponse>(getContentDeleteUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deleteContentBody),
  });
};

export const getContentDeleteMutationKey = () => ['contentDelete'] as const;

export const getContentDeleteMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof contentDelete>>,
    TError,
    ContentDeleteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof contentDelete>>,
  TError,
  ContentDeleteMutationVariables,
  TContext
> => {
  const mutationKey = getContentDeleteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof contentDelete>>,
    ContentDeleteMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return contentDelete(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ContentDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof contentDelete>>>;
export type ContentDeleteMutationBody = DeleteContentBody;
export type ContentDeleteMutationError = ErrorResponse;
export type ContentDeleteMutationVariables = { data: DeleteContentBody };

/**
 * @summary Delete content lineages and everything they contain
 */
export const useContentDelete = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof contentDelete>>,
      TError,
      ContentDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof contentDelete>>,
  TError,
  ContentDeleteMutationVariables,
  TContext
> => {
  return useMutation(getContentDeleteMutationOptions(options), queryClient);
};

export type graphMutationResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type graphMutationResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type graphMutationResponse403 = {
  data: ErrorResponse;
  status: 403;
};
export type graphMutationResponseError = (
  | graphMutationResponse400
  | graphMutationResponse401
  | graphMutationResponse403
) & {
  headers: Headers;
};

export type graphMutationResponse = graphMutationResponseError;

export const getGraphMutationUrl = () => {
  return `/api/v1/content/graph-mutations`;
};

/**
 * Direct execution is disabled. User-owned graph mutations must be previewed and then executed after UI approval.
 * @summary Deprecated direct graph mutation execution
 */
export const graphMutation = async (
  graphMutationBody: GraphMutationBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<graphMutationResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<graphMutationResponse>(getGraphMutationUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(graphMutationBody),
  });
};

export const getGraphMutationMutationKey = () => ['graphMutation'] as const;

export const getGraphMutationMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof graphMutation>>,
    TError,
    GraphMutationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof graphMutation>>,
  TError,
  GraphMutationMutationVariables,
  TContext
> => {
  const mutationKey = getGraphMutationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof graphMutation>>,
    GraphMutationMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return graphMutation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GraphMutationMutationResult = NonNullable<Awaited<ReturnType<typeof graphMutation>>>;
export type GraphMutationMutationBody = GraphMutationBody;
export type GraphMutationMutationError = ErrorResponse;
export type GraphMutationMutationVariables = { data: GraphMutationBody };

/**
 * @summary Deprecated direct graph mutation execution
 */
export const useGraphMutation = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof graphMutation>>,
      TError,
      GraphMutationMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof graphMutation>>,
  TError,
  GraphMutationMutationVariables,
  TContext
> => {
  return useMutation(getGraphMutationMutationOptions(options), queryClient);
};

export type executeApprovedGraphMutationResponse200 = {
  data: GraphMutationResponse;
  status: 200;
};

export type executeApprovedGraphMutationResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type executeApprovedGraphMutationResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type executeApprovedGraphMutationResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type executeApprovedGraphMutationResponse409 = {
  data: ErrorResponse;
  status: 409;
};

export type executeApprovedGraphMutationResponse503 = {
  data: ErrorResponse;
  status: 503;
};

export type executeApprovedGraphMutationResponseSuccess =
  executeApprovedGraphMutationResponse200 & {
    headers: Headers;
  };
export type executeApprovedGraphMutationResponseError = (
  | executeApprovedGraphMutationResponse400
  | executeApprovedGraphMutationResponse401
  | executeApprovedGraphMutationResponse403
  | executeApprovedGraphMutationResponse409
  | executeApprovedGraphMutationResponse503
) & {
  headers: Headers;
};

export type executeApprovedGraphMutationResponse =
  | executeApprovedGraphMutationResponseSuccess
  | executeApprovedGraphMutationResponseError;

export const getExecuteApprovedGraphMutationUrl = () => {
  return `/api/v1/content/graph-mutations/execute-approved`;
};

/**
 * Revalidates the canonical mutation, claims its Redis idempotency guard, and executes it as the real user.
 * @summary Execute an approved graph mutation
 */
export const executeApprovedGraphMutation = async (
  executeApprovedGraphMutationBody: ExecuteApprovedGraphMutationBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<executeApprovedGraphMutationResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<executeApprovedGraphMutationResponse>(
    getExecuteApprovedGraphMutationUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
      body: JSON.stringify(executeApprovedGraphMutationBody),
    },
  );
};

export const getExecuteApprovedGraphMutationMutationKey = () =>
  ['executeApprovedGraphMutation'] as const;

export const getExecuteApprovedGraphMutationMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof executeApprovedGraphMutation>>,
    TError,
    ExecuteApprovedGraphMutationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof executeApprovedGraphMutation>>,
  TError,
  ExecuteApprovedGraphMutationMutationVariables,
  TContext
> => {
  const mutationKey = getExecuteApprovedGraphMutationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof executeApprovedGraphMutation>>,
    ExecuteApprovedGraphMutationMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return executeApprovedGraphMutation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExecuteApprovedGraphMutationMutationResult = NonNullable<
  Awaited<ReturnType<typeof executeApprovedGraphMutation>>
>;
export type ExecuteApprovedGraphMutationMutationBody = ExecuteApprovedGraphMutationBody;
export type ExecuteApprovedGraphMutationMutationError = ErrorResponse;
export type ExecuteApprovedGraphMutationMutationVariables = {
  data: ExecuteApprovedGraphMutationBody;
};

/**
 * @summary Execute an approved graph mutation
 */
export const useExecuteApprovedGraphMutation = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof executeApprovedGraphMutation>>,
      TError,
      ExecuteApprovedGraphMutationMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof executeApprovedGraphMutation>>,
  TError,
  ExecuteApprovedGraphMutationMutationVariables,
  TContext
> => {
  return useMutation(getExecuteApprovedGraphMutationMutationOptions(options), queryClient);
};

export type previewGraphMutationApprovalResponse200 = {
  data: GraphMutationApprovalPreviewResponse;
  status: 200;
};

export type previewGraphMutationApprovalResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type previewGraphMutationApprovalResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type previewGraphMutationApprovalResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type previewGraphMutationApprovalResponseSuccess =
  previewGraphMutationApprovalResponse200 & {
    headers: Headers;
  };
export type previewGraphMutationApprovalResponseError = (
  | previewGraphMutationApprovalResponse400
  | previewGraphMutationApprovalResponse401
  | previewGraphMutationApprovalResponse403
) & {
  headers: Headers;
};

export type previewGraphMutationApprovalResponse =
  | previewGraphMutationApprovalResponseSuccess
  | previewGraphMutationApprovalResponseError;

export const getPreviewGraphMutationApprovalUrl = () => {
  return `/api/v1/content/graph-mutations/preview`;
};

/**
 * Canonicalizes and validates an exact user-owned graph mutation for UI review.
 * @summary Preview a user-owned graph mutation approval
 */
export const previewGraphMutationApproval = async (
  graphMutationApprovalPreviewBody: GraphMutationApprovalPreviewBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<previewGraphMutationApprovalResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<previewGraphMutationApprovalResponse>(
    getPreviewGraphMutationApprovalUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
      body: JSON.stringify(graphMutationApprovalPreviewBody),
    },
  );
};

export const getPreviewGraphMutationApprovalMutationKey = () =>
  ['previewGraphMutationApproval'] as const;

export const getPreviewGraphMutationApprovalMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewGraphMutationApproval>>,
    TError,
    PreviewGraphMutationApprovalMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewGraphMutationApproval>>,
  TError,
  PreviewGraphMutationApprovalMutationVariables,
  TContext
> => {
  const mutationKey = getPreviewGraphMutationApprovalMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewGraphMutationApproval>>,
    PreviewGraphMutationApprovalMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return previewGraphMutationApproval(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewGraphMutationApprovalMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewGraphMutationApproval>>
>;
export type PreviewGraphMutationApprovalMutationBody = GraphMutationApprovalPreviewBody;
export type PreviewGraphMutationApprovalMutationError = ErrorResponse;
export type PreviewGraphMutationApprovalMutationVariables = {
  data: GraphMutationApprovalPreviewBody;
};

/**
 * @summary Preview a user-owned graph mutation approval
 */
export const usePreviewGraphMutationApproval = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof previewGraphMutationApproval>>,
      TError,
      PreviewGraphMutationApprovalMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof previewGraphMutationApproval>>,
  TError,
  PreviewGraphMutationApprovalMutationVariables,
  TContext
> => {
  return useMutation(getPreviewGraphMutationApprovalMutationOptions(options), queryClient);
};

export type createInstancesResponse200 = {
  data: CreateContentResponse;
  status: 200;
};

export type createInstancesResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type createInstancesResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type createInstancesResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type createInstancesResponseSuccess = createInstancesResponse200 & {
  headers: Headers;
};
export type createInstancesResponseError = (
  | createInstancesResponse400
  | createInstancesResponse401
  | createInstancesResponse403
) & {
  headers: Headers;
};

export type createInstancesResponse = createInstancesResponseSuccess | createInstancesResponseError;

export const getCreateInstancesUrl = () => {
  return `/api/v1/content/instances`;
};

/**
 * Creates one or more content INSTANCE nodes (concrete data referencing a content TYPE) wired by semantic edges (contains / includes / relatesTo). Delegates to the same content mutation pipeline as the GraphQL `mutateContent` mutation. Allows USER, GROUP, or AGENT actors.
 * @summary Create content INSTANCE nodes
 */
export const createInstances = async (
  createInstancesBody: CreateInstancesBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<createInstancesResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<createInstancesResponse>(getCreateInstancesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createInstancesBody),
  });
};

export const getCreateInstancesMutationKey = () => ['createInstances'] as const;

export const getCreateInstancesMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInstances>>,
    TError,
    CreateInstancesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInstances>>,
  TError,
  CreateInstancesMutationVariables,
  TContext
> => {
  const mutationKey = getCreateInstancesMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInstances>>,
    CreateInstancesMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createInstances(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInstancesMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInstances>>
>;
export type CreateInstancesMutationBody = CreateInstancesBody;
export type CreateInstancesMutationError = ErrorResponse;
export type CreateInstancesMutationVariables = { data: CreateInstancesBody };

/**
 * @summary Create content INSTANCE nodes
 */
export const useCreateInstances = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createInstances>>,
      TError,
      CreateInstancesMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createInstances>>,
  TError,
  CreateInstancesMutationVariables,
  TContext
> => {
  return useMutation(getCreateInstancesMutationOptions(options), queryClient);
};

export type mutateResponse200 = {
  data: MutateContentResponse;
  status: 200;
};

export type mutateResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type mutateResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type mutateResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type mutateResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type mutateResponse409 = {
  data: ErrorResponse;
  status: 409;
};

export type mutateResponseSuccess = mutateResponse200 & {
  headers: Headers;
};
export type mutateResponseError = (
  | mutateResponse400
  | mutateResponse401
  | mutateResponse403
  | mutateResponse404
  | mutateResponse409
) & {
  headers: Headers;
};

export type mutateResponse = mutateResponseSuccess | mutateResponseError;

export const getMutateUrl = () => {
  return `/api/v1/content/mutate`;
};

/**
 * Applies `addNodes`, `editNodes`, `addFiles`, `setEdges` and `removeEdges` as ONE transaction and returns the identities the write produced. The acknowledgement is the authoritative save result: stamp the returned UUIDs and lineages before reloading, and treat a failed read-back afterwards as a refresh failure, not a failed save.
 *
 * Every command object is strict — an unknown field is a 400 naming its path, never a silently dropped setting.
 *
 * `idempotencyKey` is required and deduplicates retries: the same id with the same command replays the stored acknowledgement without writing again, and the same id with a different command is a 409.
 *
 * Send `expectedOutgoingRevision` (from GET) to guard an edge-only edit: the source node’s UUID does not move when its edges change, so a node version alone cannot detect a concurrent structural edit.
 *
 * Whole-content deletion is not part of this route; it stays on the existing delete endpoints.
 * @summary Apply one bounded batch of content changes
 */
export const mutate = async (
  mutateContentBody: MutateContentBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<mutateResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<mutateResponse>(getMutateUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(mutateContentBody),
  });
};

export const getMutateMutationKey = () => ['mutate'] as const;

export const getMutateMutationOptions = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mutate>>,
    TError,
    MutateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mutate>>,
  TError,
  MutateMutationVariables,
  TContext
> => {
  const mutationKey = getMutateMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mutate>>,
    MutateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return mutate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MutateMutationResult = NonNullable<Awaited<ReturnType<typeof mutate>>>;
export type MutateMutationBody = MutateContentBody;
export type MutateMutationError = ErrorResponse;
export type MutateMutationVariables = { data: MutateContentBody };

/**
 * @summary Apply one bounded batch of content changes
 */
export const useMutate = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mutate>>,
      TError,
      MutateMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof mutate>>,
  TError,
  MutateMutationVariables,
  TContext
> => {
  return useMutation(getMutateMutationOptions(options), queryClient);
};

export type searchContentResponse200 = {
  data: SearchContentResponse;
  status: 200;
};

export type searchContentResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type searchContentResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type searchContentResponseSuccess = searchContentResponse200 & {
  headers: Headers;
};
export type searchContentResponseError = (searchContentResponse400 | searchContentResponse401) & {
  headers: Headers;
};

export type searchContentResponse = searchContentResponseSuccess | searchContentResponseError;

export const getSearchContentUrl = () => {
  return `/api/v1/content/search`;
};

/**
 * INSTANCE mode (default) searches root content the authenticated actor can READ. Filters: root content type, case-insensitive title terms, graph predicates over descendant values (typed path + operator + value; all predicates must match) and actor predicates. Matched roots are returned hydrated to maxDepth. TYPE mode (`variant: TYPE`) lists live content types the actor can READ, filtered by type-name terms, actor predicates and kind, with no graph hydrated. Both modes return `hits` in order and page by cursor: pass `pageInfo.endCursor` as `after`. totalCount is counted on a first page only. For a user who belongs to a group homed in another region, the search also runs in that region and the pages merge into one order; such a response carries `partial`, `unavailableRegions` and `totalCountIsLowerBound`, and pages with `after`, or by offset within its first 1000 rows.
 * @summary Search content, or content types, by type, value and relations
 */
export const searchContent = async (
  searchContentBody: SearchContentBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<searchContentResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<searchContentResponse>(getSearchContentUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(searchContentBody),
  });
};

export const getSearchContentMutationKey = () => ['searchContent'] as const;

export const getSearchContentMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchContent>>,
    TError,
    SearchContentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchContent>>,
  TError,
  SearchContentMutationVariables,
  TContext
> => {
  const mutationKey = getSearchContentMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchContent>>,
    SearchContentMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return searchContent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchContentMutationResult = NonNullable<Awaited<ReturnType<typeof searchContent>>>;
export type SearchContentMutationBody = SearchContentBody;
export type SearchContentMutationError = ErrorResponse;
export type SearchContentMutationVariables = { data: SearchContentBody };

/**
 * @summary Search content, or content types, by type, value and relations
 */
export const useSearchContent = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchContent>>,
      TError,
      SearchContentMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchContent>>,
  TError,
  SearchContentMutationVariables,
  TContext
> => {
  return useMutation(getSearchContentMutationOptions(options), queryClient);
};

export type shareResponse200 = {
  data: ShareContentResponse;
  status: 200;
};

export type shareResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type shareResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type shareResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type shareResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type shareResponse409 = {
  data: ErrorResponse;
  status: 409;
};

export type shareResponseSuccess = shareResponse200 & {
  headers: Headers;
};
export type shareResponseError = (
  | shareResponse400
  | shareResponse401
  | shareResponse403
  | shareResponse404
  | shareResponse409
) & {
  headers: Headers;
};

export type shareResponse = shareResponseSuccess | shareResponseError;

export const getShareUrl = () => {
  return `/api/v1/content/share`;
};

/**
 * The standard share dialog. Grants (USER, GROUP, GROUP_MEMBERS, PUBLIC), email invitations and revocations on one or more lineages, applied as ONE all-or-nothing transaction. A grant creates access, raises it, or — when its permissions are lower or its expiry differs — replaces it, lowering whatever the audience authored under it to the new level. `includeDescendants` applies everything to what each lineage CONTAINS too. Requires SHARE on every lineage.
 *
 * New recipients are notified after the commit. `idempotencyKey` is required: the same key with the same command replays the stored acknowledgement (`replayed: true`), and the same key with a different command is a 409.
 * @summary Grant, change and revoke access to content
 */
export const share = async (
  shareContentBody: ShareContentBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<shareResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<shareResponse>(getShareUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(shareContentBody),
  });
};

export const getShareMutationKey = () => ['share'] as const;

export const getShareMutationOptions = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof share>>,
    TError,
    ShareMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof share>>,
  TError,
  ShareMutationVariables,
  TContext
> => {
  const mutationKey = getShareMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof share>>, ShareMutationVariables> = (
    props,
  ) => {
    const { data } = props ?? {};

    return share(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ShareMutationResult = NonNullable<Awaited<ReturnType<typeof share>>>;
export type ShareMutationBody = ShareContentBody;
export type ShareMutationError = ErrorResponse;
export type ShareMutationVariables = { data: ShareContentBody };

/**
 * @summary Grant, change and revoke access to content
 */
export const useShare = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof share>>,
      TError,
      ShareMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof share>>,
  TError,
  ShareMutationVariables,
  TContext
> => {
  return useMutation(getShareMutationOptions(options), queryClient);
};

export type listTypesResponse200 = {
  data: ListContentTypesResponse;
  status: 200;
};

export type listTypesResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type listTypesResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type listTypesResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type listTypesResponseSuccess = listTypesResponse200 & {
  headers: Headers;
};
export type listTypesResponseError = (
  | listTypesResponse400
  | listTypesResponse401
  | listTypesResponse403
) & {
  headers: Headers;
};

export type listTypesResponse = listTypesResponseSuccess | listTypesResponseError;

export const getListTypesUrl = (params?: ListTypesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/content/types?${stringifiedParams}`
    : `/api/v1/content/types`;
};

/**
 * Returns the content types the caller may create instances from: types owned by the acting actor, plus types explicitly shared with the group named by `viewActorUuid`. Sharing is what lets a SYSTEM-owned type be offered to specific groups without transferring its ownership. PUBLIC system types are excluded — readable is not creatable. Use `instantiable=true` for the create-from-type menu: types that declare schema slots or directly contain body data, and can therefore seed a document. `kind=complex` remains the older count-derived split over declared fields only, and does not see a template whose content is its body.
 * @summary List content types available to create instances from
 */
export const listTypes = async (
  params?: ListTypesParams,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<listTypesResponse> => {
  return onearlyRequest<listTypesResponse>(getListTypesUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getListTypesQueryKey = (params?: ListTypesParams) => {
  return [`/api/v1/content/types`, ...(params ? [params] : [])] as const;
};

export const getListTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof listTypes>>,
  TError = ErrorResponse,
>(
  params?: ListTypesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTypes>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTypesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTypes>>> = ({ signal }) =>
    listTypes(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTypes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTypesQueryResult = NonNullable<Awaited<ReturnType<typeof listTypes>>>;
export type ListTypesQueryError = ErrorResponse;

export function useListTypes<TData = Awaited<ReturnType<typeof listTypes>>, TError = ErrorResponse>(
  params: undefined | ListTypesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTypes>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTypes>>,
          TError,
          Awaited<ReturnType<typeof listTypes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTypes<TData = Awaited<ReturnType<typeof listTypes>>, TError = ErrorResponse>(
  params?: ListTypesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTypes>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTypes>>,
          TError,
          Awaited<ReturnType<typeof listTypes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTypes<TData = Awaited<ReturnType<typeof listTypes>>, TError = ErrorResponse>(
  params?: ListTypesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTypes>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List content types available to create instances from
 */

export function useListTypes<TData = Awaited<ReturnType<typeof listTypes>>, TError = ErrorResponse>(
  params?: ListTypesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTypes>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListTypesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createTypesResponse200 = {
  data: CreateContentResponse;
  status: 200;
};

export type createTypesResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type createTypesResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type createTypesResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type createTypesResponseSuccess = createTypesResponse200 & {
  headers: Headers;
};
export type createTypesResponseError = (
  | createTypesResponse400
  | createTypesResponse401
  | createTypesResponse403
) & {
  headers: Headers;
};

export type createTypesResponse = createTypesResponseSuccess | createTypesResponseError;

export const getCreateTypesUrl = () => {
  return `/api/v1/content/types`;
};

/**
 * Creates one or more content TYPE nodes (schema fields) wired by semantic edges (contains / includes / relatesTo). Delegates to the same content mutation pipeline as the GraphQL `mutateContent` mutation. Requires a USER or GROUP actor.
 * @summary Create content TYPE nodes
 */
export const createTypes = async (
  createTypesBody: CreateTypesBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<createTypesResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<createTypesResponse>(getCreateTypesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createTypesBody),
  });
};

export const getCreateTypesMutationKey = () => ['createTypes'] as const;

export const getCreateTypesMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTypes>>,
    TError,
    CreateTypesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTypes>>,
  TError,
  CreateTypesMutationVariables,
  TContext
> => {
  const mutationKey = getCreateTypesMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTypes>>,
    CreateTypesMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createTypes(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTypesMutationResult = NonNullable<Awaited<ReturnType<typeof createTypes>>>;
export type CreateTypesMutationBody = CreateTypesBody;
export type CreateTypesMutationError = ErrorResponse;
export type CreateTypesMutationVariables = { data: CreateTypesBody };

/**
 * @summary Create content TYPE nodes
 */
export const useCreateTypes = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTypes>>,
      TError,
      CreateTypesMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createTypes>>,
  TError,
  CreateTypesMutationVariables,
  TContext
> => {
  return useMutation(getCreateTypesMutationOptions(options), queryClient);
};

export type updateTypeResponse200 = {
  data: CreateContentResponse;
  status: 200;
};

export type updateTypeResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type updateTypeResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type updateTypeResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type updateTypeResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type updateTypeResponseSuccess = updateTypeResponse200 & {
  headers: Headers;
};
export type updateTypeResponseError = (
  | updateTypeResponse400
  | updateTypeResponse401
  | updateTypeResponse403
  | updateTypeResponse404
) & {
  headers: Headers;
};

export type updateTypeResponse = updateTypeResponseSuccess | updateTypeResponseError;

export const getUpdateTypeUrl = (uuid: string) => {
  return `/api/v1/content/types/${uuid}`;
};

/**
 * Updates a single TYPE row by its lineage UUID — its name, definition config (description and enum options), and/or its outgoing TYPE-to-TYPE edges. Omitted properties keep their stored value; a provided typeDefinition replaces each provided sub-field of the config bag, preserving omitted sub-fields. The scalar value type is immutable. The contains/includes/relatesTo groups are the same shape as the create endpoints, but are DECLARATIVE here: each supplied group is the complete desired set of edges of that type (adds, removes, retargets and reorders resolve from one diff), `[]` clears the group, and an omitted group is left untouched. `from` defaults to the TYPE being updated. Only TYPE-to-TYPE edges are governed — a TYPE's INSTANCE children (e.g. a template's body) are never affected, and detaching an edge does not delete data already populated on existing instances. Requires a USER or GROUP actor.
 * @summary Update a content TYPE definition
 */
export const updateType = async (
  uuid: string,
  updateTypeBody: UpdateTypeBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<updateTypeResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<updateTypeResponse>(getUpdateTypeUrl(uuid), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateTypeBody),
  });
};

export const getUpdateTypeMutationKey = () => ['updateType'] as const;

export const getUpdateTypeMutationOptions = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateType>>,
    TError,
    UpdateTypeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateType>>,
  TError,
  UpdateTypeMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateTypeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateType>>,
    UpdateTypeMutationVariables
  > = (props) => {
    const { uuid, data } = props ?? {};

    return updateType(uuid, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTypeMutationResult = NonNullable<Awaited<ReturnType<typeof updateType>>>;
export type UpdateTypeMutationBody = UpdateTypeBody;
export type UpdateTypeMutationError = ErrorResponse;
export type UpdateTypeMutationVariables = { uuid: string; data: UpdateTypeBody };

/**
 * @summary Update a content TYPE definition
 */
export const useUpdateType = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateType>>,
      TError,
      UpdateTypeMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateType>>,
  TError,
  UpdateTypeMutationVariables,
  TContext
> => {
  return useMutation(getUpdateTypeMutationOptions(options), queryClient);
};

export type getLatestResponse200 = {
  data: GetContentLatestResponse;
  status: 200;
};

export type getLatestResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type getLatestResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type getLatestResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type getLatestResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type getLatestResponseSuccess = getLatestResponse200 & {
  headers: Headers;
};
export type getLatestResponseError = (
  | getLatestResponse400
  | getLatestResponse401
  | getLatestResponse403
  | getLatestResponse404
) & {
  headers: Headers;
};

export type getLatestResponse = getLatestResponseSuccess | getLatestResponseError;

export const getGetLatestUrl = (lineageUuid: string, params?: GetLatestParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/content/${lineageUuid}?${stringifiedParams}`
    : `/api/v1/content/${lineageUuid}`;
};

/**
 * Returns the current head of `lineageUuid` together with the graph the caller may read: nodes with both version and lineage identifiers, full native values (including `valueType: JSON`), TYPE definitions with metadata / enum labels / reference, file and signature config, schema, body and reference edges with their `edgeKey`, `edgeDescription`, cardinality, position and copy semantics, actor edges, hydrated actors, per-node contributors and grant counts, and referenced TYPE rows. Units are omitted from native reads. Permission filtering is the read SQL’s: nodes the caller cannot read are absent, and so is any edge with an endpoint they cannot read. Unauthenticated callers read as PUBLIC and may pass `accessGrantUuid` (+ the `X-Content-Grant-Pin` header) to read through a share link.
 * @summary Read the latest visible content graph for a lineage
 */
export const getLatest = async (
  lineageUuid: string,
  params?: GetLatestParams,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<getLatestResponse> => {
  return onearlyRequest<getLatestResponse>(getGetLatestUrl(lineageUuid, params), {
    ...options,
    method: 'GET',
  });
};

export const getGetLatestQueryKey = (lineageUuid: string, params?: GetLatestParams) => {
  return [`/api/v1/content/${lineageUuid}`, ...(params ? [params] : [])] as const;
};

export const getGetLatestQueryOptions = <
  TData = Awaited<ReturnType<typeof getLatest>>,
  TError = ErrorResponse,
>(
  lineageUuid: string,
  params?: GetLatestParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatest>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLatestQueryKey(lineageUuid, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatest>>> = ({ signal }) =>
    getLatest(lineageUuid, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: lineageUuid !== null && lineageUuid !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getLatest>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetLatestQueryResult = NonNullable<Awaited<ReturnType<typeof getLatest>>>;
export type GetLatestQueryError = ErrorResponse;

export function useGetLatest<TData = Awaited<ReturnType<typeof getLatest>>, TError = ErrorResponse>(
  lineageUuid: string,
  params: undefined | GetLatestParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatest>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatest>>,
          TError,
          Awaited<ReturnType<typeof getLatest>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLatest<TData = Awaited<ReturnType<typeof getLatest>>, TError = ErrorResponse>(
  lineageUuid: string,
  params?: GetLatestParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatest>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatest>>,
          TError,
          Awaited<ReturnType<typeof getLatest>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLatest<TData = Awaited<ReturnType<typeof getLatest>>, TError = ErrorResponse>(
  lineageUuid: string,
  params?: GetLatestParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatest>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Read the latest visible content graph for a lineage
 */

export function useGetLatest<TData = Awaited<ReturnType<typeof getLatest>>, TError = ErrorResponse>(
  lineageUuid: string,
  params?: GetLatestParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatest>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLatestQueryOptions(lineageUuid, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type downloadContentPdfResponse200 = {
  data: Blob;
  status: 200;
};

export type downloadContentPdfResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type downloadContentPdfResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type downloadContentPdfResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type downloadContentPdfResponse502 = {
  data: ErrorResponse;
  status: 502;
};

export type downloadContentPdfResponseSuccess = downloadContentPdfResponse200 & {
  headers: Headers;
};
export type downloadContentPdfResponseError = (
  | downloadContentPdfResponse401
  | downloadContentPdfResponse403
  | downloadContentPdfResponse404
  | downloadContentPdfResponse502
) & {
  headers: Headers;
};

export type downloadContentPdfResponse =
  | downloadContentPdfResponseSuccess
  | downloadContentPdfResponseError;

export const getDownloadContentPdfUrl = (
  lineageUuid: string,
  params?: DownloadContentPdfParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/content/${lineageUuid}/pdf?${stringifiedParams}`
    : `/api/v1/content/${lineageUuid}/pdf`;
};

/**
 * Renders the content graph rooted at `lineageUuid` to a PDF using the template registered for its content type (walking the parent-type chain, falling back to the generic report) and streams the file back synchronously. Unauthenticated callers may pass `accessGrant` (+ `accessGrantPin`) to export via a share link.
 * @summary Render content as a PDF
 */
export const downloadContentPdf = async (
  lineageUuid: string,
  params?: DownloadContentPdfParams,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<downloadContentPdfResponse> => {
  return onearlyRequest<downloadContentPdfResponse>(getDownloadContentPdfUrl(lineageUuid, params), {
    ...options,
    method: 'GET',
  });
};

export const getDownloadContentPdfQueryKey = (
  lineageUuid: string,
  params?: DownloadContentPdfParams,
) => {
  return [`/api/v1/content/${lineageUuid}/pdf`, ...(params ? [params] : [])] as const;
};

export const getDownloadContentPdfQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadContentPdf>>,
  TError = ErrorResponse,
>(
  lineageUuid: string,
  params?: DownloadContentPdfParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadContentPdf>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadContentPdfQueryKey(lineageUuid, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadContentPdf>>> = ({ signal }) =>
    downloadContentPdf(lineageUuid, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: lineageUuid !== null && lineageUuid !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof downloadContentPdf>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type DownloadContentPdfQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadContentPdf>>
>;
export type DownloadContentPdfQueryError = ErrorResponse;

export function useDownloadContentPdf<
  TData = Awaited<ReturnType<typeof downloadContentPdf>>,
  TError = ErrorResponse,
>(
  lineageUuid: string,
  params: undefined | DownloadContentPdfParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadContentPdf>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadContentPdf>>,
          TError,
          Awaited<ReturnType<typeof downloadContentPdf>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadContentPdf<
  TData = Awaited<ReturnType<typeof downloadContentPdf>>,
  TError = ErrorResponse,
>(
  lineageUuid: string,
  params?: DownloadContentPdfParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadContentPdf>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadContentPdf>>,
          TError,
          Awaited<ReturnType<typeof downloadContentPdf>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadContentPdf<
  TData = Awaited<ReturnType<typeof downloadContentPdf>>,
  TError = ErrorResponse,
>(
  lineageUuid: string,
  params?: DownloadContentPdfParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadContentPdf>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Render content as a PDF
 */

export function useDownloadContentPdf<
  TData = Awaited<ReturnType<typeof downloadContentPdf>>,
  TError = ErrorResponse,
>(
  lineageUuid: string,
  params?: DownloadContentPdfParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadContentPdf>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDownloadContentPdfQueryOptions(lineageUuid, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getSharingResponse200 = {
  data: GetContentSharingResponse;
  status: 200;
};

export type getSharingResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type getSharingResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type getSharingResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type getSharingResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type getSharingResponseSuccess = getSharingResponse200 & {
  headers: Headers;
};
export type getSharingResponseError = (
  | getSharingResponse400
  | getSharingResponse401
  | getSharingResponse403
  | getSharingResponse404
) & {
  headers: Headers;
};

export type getSharingResponse = getSharingResponseSuccess | getSharingResponseError;

export const getGetSharingUrl = (lineageUuid: string, params?: GetSharingParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/content/${lineageUuid}/sharing?${stringifiedParams}`
    : `/api/v1/content/${lineageUuid}/sharing`;
};

/**
 * Every access row on the lineage’s current head: its authors and its shares, each with the principal it is stored under (type, uuid, scope), the mask and its permission names, the expiry, and the actor to show (with the email for a person). Share links too, when the caller also holds SHARE. The REST replacement for GraphQL `getContentSharing`, behind the same gate: EDIT on the content, directly or through the containment chain. A caller without it gets a 403 and no rows.
 * @summary Who has access to content, for the share dialog
 */
export const getSharing = async (
  lineageUuid: string,
  params?: GetSharingParams,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<getSharingResponse> => {
  return onearlyRequest<getSharingResponse>(getGetSharingUrl(lineageUuid, params), {
    ...options,
    method: 'GET',
  });
};

export const getGetSharingQueryKey = (lineageUuid: string, params?: GetSharingParams) => {
  return [`/api/v1/content/${lineageUuid}/sharing`, ...(params ? [params] : [])] as const;
};

export const getGetSharingQueryOptions = <
  TData = Awaited<ReturnType<typeof getSharing>>,
  TError = ErrorResponse,
>(
  lineageUuid: string,
  params?: GetSharingParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharing>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSharingQueryKey(lineageUuid, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSharing>>> = ({ signal }) =>
    getSharing(lineageUuid, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: lineageUuid !== null && lineageUuid !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getSharing>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetSharingQueryResult = NonNullable<Awaited<ReturnType<typeof getSharing>>>;
export type GetSharingQueryError = ErrorResponse;

export function useGetSharing<
  TData = Awaited<ReturnType<typeof getSharing>>,
  TError = ErrorResponse,
>(
  lineageUuid: string,
  params: undefined | GetSharingParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharing>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharing>>,
          TError,
          Awaited<ReturnType<typeof getSharing>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharing<
  TData = Awaited<ReturnType<typeof getSharing>>,
  TError = ErrorResponse,
>(
  lineageUuid: string,
  params?: GetSharingParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharing>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharing>>,
          TError,
          Awaited<ReturnType<typeof getSharing>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharing<
  TData = Awaited<ReturnType<typeof getSharing>>,
  TError = ErrorResponse,
>(
  lineageUuid: string,
  params?: GetSharingParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharing>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Who has access to content, for the share dialog
 */

export function useGetSharing<
  TData = Awaited<ReturnType<typeof getSharing>>,
  TError = ErrorResponse,
>(
  lineageUuid: string,
  params?: GetSharingParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharing>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSharingQueryOptions(lineageUuid, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createGroupResponse201 = {
  data: CreateGroupResponse;
  status: 201;
};

export type createGroupResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type createGroupResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type createGroupResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type createGroupResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type createGroupResponse409 = {
  data: ErrorResponse;
  status: 409;
};

export type createGroupResponse422 = {
  data: ErrorResponse;
  status: 422;
};

export type createGroupResponseSuccess = createGroupResponse201 & {
  headers: Headers;
};
export type createGroupResponseError = (
  | createGroupResponse400
  | createGroupResponse401
  | createGroupResponse403
  | createGroupResponse404
  | createGroupResponse409
  | createGroupResponse422
) & {
  headers: Headers;
};

export type createGroupResponse = createGroupResponseSuccess | createGroupResponseError;

export const getCreateGroupUrl = () => {
  return `/api/v1/groups`;
};

/**
 * Creates a group with the caller as its Admin. With parentGroupActorUuid it is a sub-group of that group, which needs the create-sub-group permission there; a sub-group cannot have sub-groups, and a SECRET group's sub-groups are SECRET.
 * @summary Create a group or a sub-group
 */
export const createGroup = async (
  createGroupBody: CreateGroupBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<createGroupResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<createGroupResponse>(getCreateGroupUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createGroupBody),
  });
};

export const getCreateGroupMutationKey = () => ['createGroup'] as const;

export const getCreateGroupMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGroup>>,
    TError,
    CreateGroupMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGroup>>,
  TError,
  CreateGroupMutationVariables,
  TContext
> => {
  const mutationKey = getCreateGroupMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGroup>>,
    CreateGroupMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createGroup(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createGroup>>>;
export type CreateGroupMutationBody = CreateGroupBody;
export type CreateGroupMutationError = ErrorResponse;
export type CreateGroupMutationVariables = { data: CreateGroupBody };

/**
 * @summary Create a group or a sub-group
 */
export const useCreateGroup = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createGroup>>,
      TError,
      CreateGroupMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createGroup>>,
  TError,
  CreateGroupMutationVariables,
  TContext
> => {
  return useMutation(getCreateGroupMutationOptions(options), queryClient);
};

export type getGroupChatResponse200 = {
  data: GroupChat;
  status: 200;
};

export type getGroupChatResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type getGroupChatResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type getGroupChatResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type getGroupChatResponse409 = {
  data: ErrorResponse;
  status: 409;
};

export type getGroupChatResponse503 = {
  data: ErrorResponse;
  status: 503;
};

export type getGroupChatResponseSuccess = getGroupChatResponse200 & {
  headers: Headers;
};
export type getGroupChatResponseError = (
  | getGroupChatResponse401
  | getGroupChatResponse403
  | getGroupChatResponse404
  | getGroupChatResponse409
  | getGroupChatResponse503
) & {
  headers: Headers;
};

export type getGroupChatResponse = getGroupChatResponseSuccess | getGroupChatResponseError;

export const getGetGroupChatUrl = (groupActorUuid: string) => {
  return `/api/v1/groups/${groupActorUuid}/chat`;
};

/**
 * The Reach thread that is the group's own chat, to open with the Reach SDK, and the region whose Reach holds it (`reachHome`, the group's home). Only for a current member of the group. A Stronger Memory group gets its chat on first open; any other group's chat has to be started first (POST). Every current member of the group is in the thread as a writer with its whole history, kept so as people join and leave. A member homed in another region is seated when they first open it over their own region's Reach.
 * @summary Open a group's chat
 */
export const getGroupChat = async (
  groupActorUuid: string,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<getGroupChatResponse> => {
  return onearlyRequest<getGroupChatResponse>(getGetGroupChatUrl(groupActorUuid), {
    ...options,
    method: 'GET',
  });
};

export const getGetGroupChatQueryKey = (groupActorUuid: string) => {
  return [`/api/v1/groups/${groupActorUuid}/chat`] as const;
};

export const getGetGroupChatQueryOptions = <
  TData = Awaited<ReturnType<typeof getGroupChat>>,
  TError = ErrorResponse,
>(
  groupActorUuid: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupChat>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGroupChatQueryKey(groupActorUuid);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroupChat>>> = ({ signal }) =>
    getGroupChat(groupActorUuid, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: groupActorUuid !== null && groupActorUuid !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getGroupChat>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetGroupChatQueryResult = NonNullable<Awaited<ReturnType<typeof getGroupChat>>>;
export type GetGroupChatQueryError = ErrorResponse;

export function useGetGroupChat<
  TData = Awaited<ReturnType<typeof getGroupChat>>,
  TError = ErrorResponse,
>(
  groupActorUuid: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupChat>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroupChat>>,
          TError,
          Awaited<ReturnType<typeof getGroupChat>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetGroupChat<
  TData = Awaited<ReturnType<typeof getGroupChat>>,
  TError = ErrorResponse,
>(
  groupActorUuid: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupChat>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroupChat>>,
          TError,
          Awaited<ReturnType<typeof getGroupChat>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetGroupChat<
  TData = Awaited<ReturnType<typeof getGroupChat>>,
  TError = ErrorResponse,
>(
  groupActorUuid: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupChat>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Open a group's chat
 */

export function useGetGroupChat<
  TData = Awaited<ReturnType<typeof getGroupChat>>,
  TError = ErrorResponse,
>(
  groupActorUuid: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupChat>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetGroupChatQueryOptions(groupActorUuid, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type startGroupChatResponse200 = {
  data: GroupChat;
  status: 200;
};

export type startGroupChatResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type startGroupChatResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type startGroupChatResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type startGroupChatResponse409 = {
  data: ErrorResponse;
  status: 409;
};

export type startGroupChatResponse503 = {
  data: ErrorResponse;
  status: 503;
};

export type startGroupChatResponseSuccess = startGroupChatResponse200 & {
  headers: Headers;
};
export type startGroupChatResponseError = (
  | startGroupChatResponse401
  | startGroupChatResponse403
  | startGroupChatResponse404
  | startGroupChatResponse409
  | startGroupChatResponse503
) & {
  headers: Headers;
};

export type startGroupChatResponse = startGroupChatResponseSuccess | startGroupChatResponseError;

export const getStartGroupChatUrl = (groupActorUuid: string) => {
  return `/api/v1/groups/${groupActorUuid}/chat`;
};

/**
 * Creates the group's chat if it has none, and answers with it either way. Needs manage-group or an act-as-group permission in the group. Its people are the group's members, whoever starts it.
 * @summary Start a group's chat
 */
export const startGroupChat = async (
  groupActorUuid: string,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<startGroupChatResponse> => {
  return onearlyRequest<startGroupChatResponse>(getStartGroupChatUrl(groupActorUuid), {
    ...options,
    method: 'POST',
  });
};

export const getStartGroupChatMutationKey = () => ['startGroupChat'] as const;

export const getStartGroupChatMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startGroupChat>>,
    TError,
    StartGroupChatMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startGroupChat>>,
  TError,
  StartGroupChatMutationVariables,
  TContext
> => {
  const mutationKey = getStartGroupChatMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startGroupChat>>,
    StartGroupChatMutationVariables
  > = (props) => {
    const { groupActorUuid } = props ?? {};

    return startGroupChat(groupActorUuid, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartGroupChatMutationResult = NonNullable<Awaited<ReturnType<typeof startGroupChat>>>;

export type StartGroupChatMutationError = ErrorResponse;
export type StartGroupChatMutationVariables = { groupActorUuid: string };

/**
 * @summary Start a group's chat
 */
export const useStartGroupChat = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof startGroupChat>>,
      TError,
      StartGroupChatMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof startGroupChat>>,
  TError,
  StartGroupChatMutationVariables,
  TContext
> => {
  return useMutation(getStartGroupChatMutationOptions(options), queryClient);
};

export type listGroupMembersResponse200 = {
  data: ListGroupMembersResponse;
  status: 200;
};

export type listGroupMembersResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type listGroupMembersResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type listGroupMembersResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type listGroupMembersResponseSuccess = listGroupMembersResponse200 & {
  headers: Headers;
};
export type listGroupMembersResponseError = (
  | listGroupMembersResponse400
  | listGroupMembersResponse401
  | listGroupMembersResponse403
) & {
  headers: Headers;
};

export type listGroupMembersResponse =
  | listGroupMembersResponseSuccess
  | listGroupMembersResponseError;

export const getListGroupMembersUrl = (groupActorUuid: string, params?: ListGroupMembersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/groups/${groupActorUuid}/members?${stringifiedParams}`
    : `/api/v1/groups/${groupActorUuid}/members`;
};

/**
 * Needs view-group-member-names or view-group-members. Each member comes with their name, picture and roles; their email only when the caller holds view-group-member-emails or view-group-members, or it is the caller's own. Never a phone number. A member with no name is named by their masked email.
 * @summary List a group's members
 */
export const listGroupMembers = async (
  groupActorUuid: string,
  params?: ListGroupMembersParams,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<listGroupMembersResponse> => {
  return onearlyRequest<listGroupMembersResponse>(getListGroupMembersUrl(groupActorUuid, params), {
    ...options,
    method: 'GET',
  });
};

export const getListGroupMembersQueryKey = (
  groupActorUuid: string,
  params?: ListGroupMembersParams,
) => {
  return [`/api/v1/groups/${groupActorUuid}/members`, ...(params ? [params] : [])] as const;
};

export const getListGroupMembersQueryOptions = <
  TData = Awaited<ReturnType<typeof listGroupMembers>>,
  TError = ErrorResponse,
>(
  groupActorUuid: string,
  params?: ListGroupMembersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupMembers>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListGroupMembersQueryKey(groupActorUuid, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listGroupMembers>>> = ({ signal }) =>
    listGroupMembers(groupActorUuid, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: groupActorUuid !== null && groupActorUuid !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listGroupMembers>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ListGroupMembersQueryResult = NonNullable<Awaited<ReturnType<typeof listGroupMembers>>>;
export type ListGroupMembersQueryError = ErrorResponse;

export function useListGroupMembers<
  TData = Awaited<ReturnType<typeof listGroupMembers>>,
  TError = ErrorResponse,
>(
  groupActorUuid: string,
  params: undefined | ListGroupMembersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupMembers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGroupMembers>>,
          TError,
          Awaited<ReturnType<typeof listGroupMembers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListGroupMembers<
  TData = Awaited<ReturnType<typeof listGroupMembers>>,
  TError = ErrorResponse,
>(
  groupActorUuid: string,
  params?: ListGroupMembersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupMembers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGroupMembers>>,
          TError,
          Awaited<ReturnType<typeof listGroupMembers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListGroupMembers<
  TData = Awaited<ReturnType<typeof listGroupMembers>>,
  TError = ErrorResponse,
>(
  groupActorUuid: string,
  params?: ListGroupMembersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupMembers>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List a group's members
 */

export function useListGroupMembers<
  TData = Awaited<ReturnType<typeof listGroupMembers>>,
  TError = ErrorResponse,
>(
  groupActorUuid: string,
  params?: ListGroupMembersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listGroupMembers>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListGroupMembersQueryOptions(groupActorUuid, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type joinGroupResponse200 = {
  data: JoinGroupResponse;
  status: 200;
};

export type joinGroupResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type joinGroupResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type joinGroupResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type joinGroupResponseSuccess = joinGroupResponse200 & {
  headers: Headers;
};
export type joinGroupResponseError = (
  | joinGroupResponse401
  | joinGroupResponse403
  | joinGroupResponse404
) & {
  headers: Headers;
};

export type joinGroupResponse = joinGroupResponseSuccess | joinGroupResponseError;

export const getJoinGroupUrl = (groupActorUuid: string) => {
  return `/api/v1/groups/${groupActorUuid}/membership`;
};

/**
 * Adds the authenticated user to a PUBLIC group with its Member role. Idempotent: joining a group the user already belongs to returns the current membership unchanged. PRIVATE groups answer 403; SECRET or unknown groups answer 404 so their existence is not revealed.
 * @summary Join a public group
 */
export const joinGroup = async (
  groupActorUuid: string,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<joinGroupResponse> => {
  return onearlyRequest<joinGroupResponse>(getJoinGroupUrl(groupActorUuid), {
    ...options,
    method: 'POST',
  });
};

export const getJoinGroupMutationKey = () => ['joinGroup'] as const;

export const getJoinGroupMutationOptions = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof joinGroup>>,
    TError,
    JoinGroupMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof joinGroup>>,
  TError,
  JoinGroupMutationVariables,
  TContext
> => {
  const mutationKey = getJoinGroupMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof joinGroup>>,
    JoinGroupMutationVariables
  > = (props) => {
    const { groupActorUuid } = props ?? {};

    return joinGroup(groupActorUuid, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type JoinGroupMutationResult = NonNullable<Awaited<ReturnType<typeof joinGroup>>>;

export type JoinGroupMutationError = ErrorResponse;
export type JoinGroupMutationVariables = { groupActorUuid: string };

/**
 * @summary Join a public group
 */
export const useJoinGroup = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof joinGroup>>,
      TError,
      JoinGroupMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof joinGroup>>,
  TError,
  JoinGroupMutationVariables,
  TContext
> => {
  return useMutation(getJoinGroupMutationOptions(options), queryClient);
};

export type listSubGroupsResponse200 = {
  data: ListSubGroupsResponse;
  status: 200;
};

export type listSubGroupsResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type listSubGroupsResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type listSubGroupsResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type listSubGroupsResponseSuccess = listSubGroupsResponse200 & {
  headers: Headers;
};
export type listSubGroupsResponseError = (
  | listSubGroupsResponse401
  | listSubGroupsResponse403
  | listSubGroupsResponse404
) & {
  headers: Headers;
};

export type listSubGroupsResponse = listSubGroupsResponseSuccess | listSubGroupsResponseError;

export const getListSubGroupsUrl = (groupActorUuid: string, params?: ListSubGroupsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/groups/${groupActorUuid}/sub-groups?${stringifiedParams}`
    : `/api/v1/groups/${groupActorUuid}/sub-groups`;
};

/**
 * The sub-groups the caller can see, by name: PUBLIC and PRIVATE ones to anyone who can see the parent, SECRET ones to their members and the parent's admins.
 * @summary List a group's sub-groups
 */
export const listSubGroups = async (
  groupActorUuid: string,
  params?: ListSubGroupsParams,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<listSubGroupsResponse> => {
  return onearlyRequest<listSubGroupsResponse>(getListSubGroupsUrl(groupActorUuid, params), {
    ...options,
    method: 'GET',
  });
};

export const getListSubGroupsQueryKey = (groupActorUuid: string, params?: ListSubGroupsParams) => {
  return [`/api/v1/groups/${groupActorUuid}/sub-groups`, ...(params ? [params] : [])] as const;
};

export const getListSubGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSubGroups>>,
  TError = ErrorResponse,
>(
  groupActorUuid: string,
  params?: ListSubGroupsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSubGroups>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSubGroupsQueryKey(groupActorUuid, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSubGroups>>> = ({ signal }) =>
    listSubGroups(groupActorUuid, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: groupActorUuid !== null && groupActorUuid !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listSubGroups>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ListSubGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof listSubGroups>>>;
export type ListSubGroupsQueryError = ErrorResponse;

export function useListSubGroups<
  TData = Awaited<ReturnType<typeof listSubGroups>>,
  TError = ErrorResponse,
>(
  groupActorUuid: string,
  params: undefined | ListSubGroupsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSubGroups>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSubGroups>>,
          TError,
          Awaited<ReturnType<typeof listSubGroups>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSubGroups<
  TData = Awaited<ReturnType<typeof listSubGroups>>,
  TError = ErrorResponse,
>(
  groupActorUuid: string,
  params?: ListSubGroupsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSubGroups>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSubGroups>>,
          TError,
          Awaited<ReturnType<typeof listSubGroups>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSubGroups<
  TData = Awaited<ReturnType<typeof listSubGroups>>,
  TError = ErrorResponse,
>(
  groupActorUuid: string,
  params?: ListSubGroupsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSubGroups>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List a group's sub-groups
 */

export function useListSubGroups<
  TData = Awaited<ReturnType<typeof listSubGroups>>,
  TError = ErrorResponse,
>(
  groupActorUuid: string,
  params?: ListSubGroupsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSubGroups>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSubGroupsQueryOptions(groupActorUuid, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type deleteMyUserAccountResponse200 = {
  data: DeleteMyUserAccountResponse;
  status: 200;
};

export type deleteMyUserAccountResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type deleteMyUserAccountResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type deleteMyUserAccountResponseSuccess = deleteMyUserAccountResponse200 & {
  headers: Headers;
};
export type deleteMyUserAccountResponseError = (
  | deleteMyUserAccountResponse401
  | deleteMyUserAccountResponse403
) & {
  headers: Headers;
};

export type deleteMyUserAccountResponse =
  | deleteMyUserAccountResponseSuccess
  | deleteMyUserAccountResponseError;

export const getDeleteMyUserAccountUrl = () => {
  return `/api/v1/users/me`;
};

/**
 * Deletes the account of the currently authenticated USER actor: removes the upstream Ory identity and soft-deletes the user. Mirrors the GraphQL `deleteUserAccount` mutation.
 * @summary Delete the authenticated user account
 */
export const deleteMyUserAccount = async (
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<deleteMyUserAccountResponse> => {
  return onearlyRequest<deleteMyUserAccountResponse>(getDeleteMyUserAccountUrl(), {
    ...options,
    method: 'DELETE',
  });
};

export const getDeleteMyUserAccountMutationKey = () => ['deleteMyUserAccount'] as const;

export const getDeleteMyUserAccountMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMyUserAccount>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteMyUserAccount>>, TError, void, TContext> => {
  const mutationKey = getDeleteMyUserAccountMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMyUserAccount>>,
    void
  > = () => {
    return deleteMyUserAccount(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMyUserAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMyUserAccount>>
>;

export type DeleteMyUserAccountMutationError = ErrorResponse;

/**
 * @summary Delete the authenticated user account
 */
export const useDeleteMyUserAccount = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMyUserAccount>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof deleteMyUserAccount>>, TError, void, TContext> => {
  return useMutation(getDeleteMyUserAccountMutationOptions(options), queryClient);
};

export type getMyUserResponse200 = {
  data: MyUser;
  status: 200;
};

export type getMyUserResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type getMyUserResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type getMyUserResponseSuccess = getMyUserResponse200 & {
  headers: Headers;
};
export type getMyUserResponseError = (getMyUserResponse401 | getMyUserResponse403) & {
  headers: Headers;
};

export type getMyUserResponse = getMyUserResponseSuccess | getMyUserResponseError;

export const getGetMyUserUrl = () => {
  return `/api/v1/users/me`;
};

/**
 * Returns the profile of the currently authenticated USER actor. Mirrors the GraphQL `getMyUser` query.
 * @summary Get the authenticated user profile
 */
export const getMyUser = async (
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<getMyUserResponse> => {
  return onearlyRequest<getMyUserResponse>(getGetMyUserUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getGetMyUserQueryKey = () => {
  return [`/api/v1/users/me`] as const;
};

export const getGetMyUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyUser>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyUser>>, TError, TData>>;
  request?: SecondParameter<typeof onearlyRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyUser>>> = ({ signal }) =>
    getMyUser({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyUserQueryResult = NonNullable<Awaited<ReturnType<typeof getMyUser>>>;
export type GetMyUserQueryError = ErrorResponse;

export function useGetMyUser<TData = Awaited<ReturnType<typeof getMyUser>>, TError = ErrorResponse>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyUser>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyUser>>,
          TError,
          Awaited<ReturnType<typeof getMyUser>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyUser<TData = Awaited<ReturnType<typeof getMyUser>>, TError = ErrorResponse>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyUser>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyUser>>,
          TError,
          Awaited<ReturnType<typeof getMyUser>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyUser<TData = Awaited<ReturnType<typeof getMyUser>>, TError = ErrorResponse>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyUser>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the authenticated user profile
 */

export function useGetMyUser<TData = Awaited<ReturnType<typeof getMyUser>>, TError = ErrorResponse>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyUser>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyUserQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type updateMyUserProfileResponse200 = {
  data: MyUser;
  status: 200;
};

export type updateMyUserProfileResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type updateMyUserProfileResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type updateMyUserProfileResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type updateMyUserProfileResponse409 = {
  data: ErrorResponse;
  status: 409;
};

export type updateMyUserProfileResponseSuccess = updateMyUserProfileResponse200 & {
  headers: Headers;
};
export type updateMyUserProfileResponseError = (
  | updateMyUserProfileResponse400
  | updateMyUserProfileResponse401
  | updateMyUserProfileResponse403
  | updateMyUserProfileResponse409
) & {
  headers: Headers;
};

export type updateMyUserProfileResponse =
  | updateMyUserProfileResponseSuccess
  | updateMyUserProfileResponseError;

export const getUpdateMyUserProfileUrl = () => {
  return `/api/v1/users/me`;
};

/**
 * Updates one or more fields on the authenticated user profile. Writes to both the content-graph profile and the upstream Ory identity (for email/phone). Mirrors the GraphQL `updateMyUserProfile` mutation.
 * @summary Update the authenticated user profile
 */
export const updateMyUserProfile = async (
  updateMyUserProfileBody: UpdateMyUserProfileBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<updateMyUserProfileResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<updateMyUserProfileResponse>(getUpdateMyUserProfileUrl(), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateMyUserProfileBody),
  });
};

export const getUpdateMyUserProfileMutationKey = () => ['updateMyUserProfile'] as const;

export const getUpdateMyUserProfileMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyUserProfile>>,
    TError,
    UpdateMyUserProfileMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyUserProfile>>,
  TError,
  UpdateMyUserProfileMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateMyUserProfileMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyUserProfile>>,
    UpdateMyUserProfileMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return updateMyUserProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMyUserProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMyUserProfile>>
>;
export type UpdateMyUserProfileMutationBody = UpdateMyUserProfileBody;
export type UpdateMyUserProfileMutationError = ErrorResponse;
export type UpdateMyUserProfileMutationVariables = { data: UpdateMyUserProfileBody };

/**
 * @summary Update the authenticated user profile
 */
export const useUpdateMyUserProfile = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMyUserProfile>>,
      TError,
      UpdateMyUserProfileMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMyUserProfile>>,
  TError,
  UpdateMyUserProfileMutationVariables,
  TContext
> => {
  return useMutation(getUpdateMyUserProfileMutationOptions(options), queryClient);
};

export type unregisterMyDeviceResponse200 = {
  data: DeviceMutationResponse;
  status: 200;
};

export type unregisterMyDeviceResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type unregisterMyDeviceResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type unregisterMyDeviceResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type unregisterMyDeviceResponseSuccess = unregisterMyDeviceResponse200 & {
  headers: Headers;
};
export type unregisterMyDeviceResponseError = (
  | unregisterMyDeviceResponse400
  | unregisterMyDeviceResponse401
  | unregisterMyDeviceResponse403
) & {
  headers: Headers;
};

export type unregisterMyDeviceResponse =
  | unregisterMyDeviceResponseSuccess
  | unregisterMyDeviceResponseError;

export const getUnregisterMyDeviceUrl = () => {
  return `/api/v1/users/me/devices`;
};

/**
 * Unregisters a push-notification device token. Idempotent — unregistering an unknown token still succeeds.
 * @summary Unregister a push-notification device token
 */
export const unregisterMyDevice = async (
  unregisterDeviceBody: UnregisterDeviceBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<unregisterMyDeviceResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<unregisterMyDeviceResponse>(getUnregisterMyDeviceUrl(), {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(unregisterDeviceBody),
  });
};

export const getUnregisterMyDeviceMutationKey = () => ['unregisterMyDevice'] as const;

export const getUnregisterMyDeviceMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unregisterMyDevice>>,
    TError,
    UnregisterMyDeviceMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unregisterMyDevice>>,
  TError,
  UnregisterMyDeviceMutationVariables,
  TContext
> => {
  const mutationKey = getUnregisterMyDeviceMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unregisterMyDevice>>,
    UnregisterMyDeviceMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return unregisterMyDevice(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnregisterMyDeviceMutationResult = NonNullable<
  Awaited<ReturnType<typeof unregisterMyDevice>>
>;
export type UnregisterMyDeviceMutationBody = UnregisterDeviceBody;
export type UnregisterMyDeviceMutationError = ErrorResponse;
export type UnregisterMyDeviceMutationVariables = { data: UnregisterDeviceBody };

/**
 * @summary Unregister a push-notification device token
 */
export const useUnregisterMyDevice = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof unregisterMyDevice>>,
      TError,
      UnregisterMyDeviceMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof unregisterMyDevice>>,
  TError,
  UnregisterMyDeviceMutationVariables,
  TContext
> => {
  return useMutation(getUnregisterMyDeviceMutationOptions(options), queryClient);
};

export type registerMyDeviceResponse200 = {
  data: DeviceMutationResponse;
  status: 200;
};

export type registerMyDeviceResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type registerMyDeviceResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type registerMyDeviceResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type registerMyDeviceResponseSuccess = registerMyDeviceResponse200 & {
  headers: Headers;
};
export type registerMyDeviceResponseError = (
  | registerMyDeviceResponse400
  | registerMyDeviceResponse401
  | registerMyDeviceResponse403
) & {
  headers: Headers;
};

export type registerMyDeviceResponse =
  | registerMyDeviceResponseSuccess
  | registerMyDeviceResponseError;

export const getRegisterMyDeviceUrl = () => {
  return `/api/v1/users/me/devices`;
};

/**
 * Registers (upserts) a push-notification device token for the authenticated USER actor, for the app named in `app` (default `onearly`). Re-registering an existing token refreshes its owner, platform, app, and last-seen timestamp.
 * @summary Register a push-notification device token
 */
export const registerMyDevice = async (
  registerDeviceBody: RegisterDeviceBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<registerMyDeviceResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<registerMyDeviceResponse>(getRegisterMyDeviceUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(registerDeviceBody),
  });
};

export const getRegisterMyDeviceMutationKey = () => ['registerMyDevice'] as const;

export const getRegisterMyDeviceMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerMyDevice>>,
    TError,
    RegisterMyDeviceMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerMyDevice>>,
  TError,
  RegisterMyDeviceMutationVariables,
  TContext
> => {
  const mutationKey = getRegisterMyDeviceMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerMyDevice>>,
    RegisterMyDeviceMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return registerMyDevice(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterMyDeviceMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerMyDevice>>
>;
export type RegisterMyDeviceMutationBody = RegisterDeviceBody;
export type RegisterMyDeviceMutationError = ErrorResponse;
export type RegisterMyDeviceMutationVariables = { data: RegisterDeviceBody };

/**
 * @summary Register a push-notification device token
 */
export const useRegisterMyDevice = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof registerMyDevice>>,
      TError,
      RegisterMyDeviceMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof registerMyDevice>>,
  TError,
  RegisterMyDeviceMutationVariables,
  TContext
> => {
  return useMutation(getRegisterMyDeviceMutationOptions(options), queryClient);
};

export type listMyEmailsResponse200 = {
  data: MyEmailsResponse;
  status: 200;
};

export type listMyEmailsResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type listMyEmailsResponse501 = {
  data: ErrorResponse;
  status: 501;
};

export type listMyEmailsResponseSuccess = listMyEmailsResponse200 & {
  headers: Headers;
};
export type listMyEmailsResponseError = (listMyEmailsResponse401 | listMyEmailsResponse501) & {
  headers: Headers;
};

export type listMyEmailsResponse = listMyEmailsResponseSuccess | listMyEmailsResponseError;

export const getListMyEmailsUrl = () => {
  return `/api/v1/users/me/emails`;
};

/**
 * Returns every email on the authenticated account — the primary plus any secondaries — with per-address verification state.
 * @summary List my email addresses
 */
export const listMyEmails = async (
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<listMyEmailsResponse> => {
  return onearlyRequest<listMyEmailsResponse>(getListMyEmailsUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getListMyEmailsQueryKey = () => {
  return [`/api/v1/users/me/emails`] as const;
};

export const getListMyEmailsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMyEmails>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyEmails>>, TError, TData>>;
  request?: SecondParameter<typeof onearlyRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMyEmailsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyEmails>>> = ({ signal }) =>
    listMyEmails({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMyEmails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMyEmailsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyEmails>>>;
export type ListMyEmailsQueryError = ErrorResponse;

export function useListMyEmails<
  TData = Awaited<ReturnType<typeof listMyEmails>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyEmails>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyEmails>>,
          TError,
          Awaited<ReturnType<typeof listMyEmails>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMyEmails<
  TData = Awaited<ReturnType<typeof listMyEmails>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyEmails>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyEmails>>,
          TError,
          Awaited<ReturnType<typeof listMyEmails>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMyEmails<
  TData = Awaited<ReturnType<typeof listMyEmails>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyEmails>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List my email addresses
 */

export function useListMyEmails<
  TData = Awaited<ReturnType<typeof listMyEmails>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyEmails>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListMyEmailsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type addMyEmailResponse200 = {
  data: AddMyEmailResponse;
  status: 200;
};

export type addMyEmailResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type addMyEmailResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type addMyEmailResponse409 = {
  data: ErrorResponse;
  status: 409;
};

export type addMyEmailResponse501 = {
  data: ErrorResponse;
  status: 501;
};

export type addMyEmailResponseSuccess = addMyEmailResponse200 & {
  headers: Headers;
};
export type addMyEmailResponseError = (
  | addMyEmailResponse400
  | addMyEmailResponse401
  | addMyEmailResponse409
  | addMyEmailResponse501
) & {
  headers: Headers;
};

export type addMyEmailResponse = addMyEmailResponseSuccess | addMyEmailResponseError;

export const getAddMyEmailUrl = () => {
  return `/api/v1/users/me/emails`;
};

/**
 * Adds a secondary email to the account (unverified) and sends a one-time verification code to it. Echo the returned verification state back on /me/emails/verify with the code.
 * @summary Add a secondary email address
 */
export const addMyEmail = async (
  addMyEmailBody: AddMyEmailBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<addMyEmailResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<addMyEmailResponse>(getAddMyEmailUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addMyEmailBody),
  });
};

export const getAddMyEmailMutationKey = () => ['addMyEmail'] as const;

export const getAddMyEmailMutationOptions = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addMyEmail>>,
    TError,
    AddMyEmailMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addMyEmail>>,
  TError,
  AddMyEmailMutationVariables,
  TContext
> => {
  const mutationKey = getAddMyEmailMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addMyEmail>>,
    AddMyEmailMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return addMyEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddMyEmailMutationResult = NonNullable<Awaited<ReturnType<typeof addMyEmail>>>;
export type AddMyEmailMutationBody = AddMyEmailBody;
export type AddMyEmailMutationError = ErrorResponse;
export type AddMyEmailMutationVariables = { data: AddMyEmailBody };

/**
 * @summary Add a secondary email address
 */
export const useAddMyEmail = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addMyEmail>>,
      TError,
      AddMyEmailMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addMyEmail>>,
  TError,
  AddMyEmailMutationVariables,
  TContext
> => {
  return useMutation(getAddMyEmailMutationOptions(options), queryClient);
};

export type setPrimaryEmailResponse200 = {
  data: MyEmailsResponse;
  status: 200;
};

export type setPrimaryEmailResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type setPrimaryEmailResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type setPrimaryEmailResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type setPrimaryEmailResponse501 = {
  data: ErrorResponse;
  status: 501;
};

export type setPrimaryEmailResponseSuccess = setPrimaryEmailResponse200 & {
  headers: Headers;
};
export type setPrimaryEmailResponseError = (
  | setPrimaryEmailResponse400
  | setPrimaryEmailResponse401
  | setPrimaryEmailResponse404
  | setPrimaryEmailResponse501
) & {
  headers: Headers;
};

export type setPrimaryEmailResponse = setPrimaryEmailResponseSuccess | setPrimaryEmailResponseError;

export const getSetPrimaryEmailUrl = () => {
  return `/api/v1/users/me/emails/primary`;
};

/**
 * Promotes a VERIFIED secondary email to primary. The primary address drives the JWT email claim and the profile email. The previous primary becomes a secondary: still verified, and still usable for one-time-code login — but NOT for password or passkey login, because only the primary trait declares those identifiers, so Kratos re-keys them to the new primary address.
 * @summary Make a verified email the primary address
 */
export const setPrimaryEmail = async (
  setPrimaryEmailBody: SetPrimaryEmailBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<setPrimaryEmailResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<setPrimaryEmailResponse>(getSetPrimaryEmailUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setPrimaryEmailBody),
  });
};

export const getSetPrimaryEmailMutationKey = () => ['setPrimaryEmail'] as const;

export const getSetPrimaryEmailMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setPrimaryEmail>>,
    TError,
    SetPrimaryEmailMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setPrimaryEmail>>,
  TError,
  SetPrimaryEmailMutationVariables,
  TContext
> => {
  const mutationKey = getSetPrimaryEmailMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setPrimaryEmail>>,
    SetPrimaryEmailMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return setPrimaryEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetPrimaryEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof setPrimaryEmail>>
>;
export type SetPrimaryEmailMutationBody = SetPrimaryEmailBody;
export type SetPrimaryEmailMutationError = ErrorResponse;
export type SetPrimaryEmailMutationVariables = { data: SetPrimaryEmailBody };

/**
 * @summary Make a verified email the primary address
 */
export const useSetPrimaryEmail = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setPrimaryEmail>>,
      TError,
      SetPrimaryEmailMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setPrimaryEmail>>,
  TError,
  SetPrimaryEmailMutationVariables,
  TContext
> => {
  return useMutation(getSetPrimaryEmailMutationOptions(options), queryClient);
};

export type removeMyEmailResponse200 = {
  data: MyEmailsResponse;
  status: 200;
};

export type removeMyEmailResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type removeMyEmailResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type removeMyEmailResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type removeMyEmailResponse501 = {
  data: ErrorResponse;
  status: 501;
};

export type removeMyEmailResponseSuccess = removeMyEmailResponse200 & {
  headers: Headers;
};
export type removeMyEmailResponseError = (
  | removeMyEmailResponse400
  | removeMyEmailResponse401
  | removeMyEmailResponse404
  | removeMyEmailResponse501
) & {
  headers: Headers;
};

export type removeMyEmailResponse = removeMyEmailResponseSuccess | removeMyEmailResponseError;

export const getRemoveMyEmailUrl = () => {
  return `/api/v1/users/me/emails/remove`;
};

/**
 * Removes a secondary email from the account. The primary cannot be removed — promote another address first.
 * @summary Remove a secondary email address
 */
export const removeMyEmail = async (
  removeMyEmailBody: RemoveMyEmailBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<removeMyEmailResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<removeMyEmailResponse>(getRemoveMyEmailUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(removeMyEmailBody),
  });
};

export const getRemoveMyEmailMutationKey = () => ['removeMyEmail'] as const;

export const getRemoveMyEmailMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeMyEmail>>,
    TError,
    RemoveMyEmailMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeMyEmail>>,
  TError,
  RemoveMyEmailMutationVariables,
  TContext
> => {
  const mutationKey = getRemoveMyEmailMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeMyEmail>>,
    RemoveMyEmailMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return removeMyEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveMyEmailMutationResult = NonNullable<Awaited<ReturnType<typeof removeMyEmail>>>;
export type RemoveMyEmailMutationBody = RemoveMyEmailBody;
export type RemoveMyEmailMutationError = ErrorResponse;
export type RemoveMyEmailMutationVariables = { data: RemoveMyEmailBody };

/**
 * @summary Remove a secondary email address
 */
export const useRemoveMyEmail = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeMyEmail>>,
      TError,
      RemoveMyEmailMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeMyEmail>>,
  TError,
  RemoveMyEmailMutationVariables,
  TContext
> => {
  return useMutation(getRemoveMyEmailMutationOptions(options), queryClient);
};

export type resendMyEmailCodeResponse200 = {
  data: ResendMyEmailCodeResponse;
  status: 200;
};

export type resendMyEmailCodeResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type resendMyEmailCodeResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type resendMyEmailCodeResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type resendMyEmailCodeResponse501 = {
  data: ErrorResponse;
  status: 501;
};

export type resendMyEmailCodeResponseSuccess = resendMyEmailCodeResponse200 & {
  headers: Headers;
};
export type resendMyEmailCodeResponseError = (
  | resendMyEmailCodeResponse400
  | resendMyEmailCodeResponse401
  | resendMyEmailCodeResponse404
  | resendMyEmailCodeResponse501
) & {
  headers: Headers;
};

export type resendMyEmailCodeResponse =
  | resendMyEmailCodeResponseSuccess
  | resendMyEmailCodeResponseError;

export const getResendMyEmailCodeUrl = () => {
  return `/api/v1/users/me/emails/resend`;
};

/**
 * Starts a fresh verification flow for an address already on the account, invalidating any previously sent code.
 * @summary Re-send the verification code for an email
 */
export const resendMyEmailCode = async (
  resendMyEmailCodeBody: ResendMyEmailCodeBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<resendMyEmailCodeResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<resendMyEmailCodeResponse>(getResendMyEmailCodeUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(resendMyEmailCodeBody),
  });
};

export const getResendMyEmailCodeMutationKey = () => ['resendMyEmailCode'] as const;

export const getResendMyEmailCodeMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendMyEmailCode>>,
    TError,
    ResendMyEmailCodeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendMyEmailCode>>,
  TError,
  ResendMyEmailCodeMutationVariables,
  TContext
> => {
  const mutationKey = getResendMyEmailCodeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendMyEmailCode>>,
    ResendMyEmailCodeMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return resendMyEmailCode(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendMyEmailCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendMyEmailCode>>
>;
export type ResendMyEmailCodeMutationBody = ResendMyEmailCodeBody;
export type ResendMyEmailCodeMutationError = ErrorResponse;
export type ResendMyEmailCodeMutationVariables = { data: ResendMyEmailCodeBody };

/**
 * @summary Re-send the verification code for an email
 */
export const useResendMyEmailCode = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resendMyEmailCode>>,
      TError,
      ResendMyEmailCodeMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resendMyEmailCode>>,
  TError,
  ResendMyEmailCodeMutationVariables,
  TContext
> => {
  return useMutation(getResendMyEmailCodeMutationOptions(options), queryClient);
};

export type verifyMyEmailResponse200 = {
  data: VerifyMyEmailResponse;
  status: 200;
};

export type verifyMyEmailResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type verifyMyEmailResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type verifyMyEmailResponse409 = {
  data: ErrorResponse;
  status: 409;
};

export type verifyMyEmailResponse501 = {
  data: ErrorResponse;
  status: 501;
};

export type verifyMyEmailResponseSuccess = verifyMyEmailResponse200 & {
  headers: Headers;
};
export type verifyMyEmailResponseError = (
  | verifyMyEmailResponse400
  | verifyMyEmailResponse401
  | verifyMyEmailResponse409
  | verifyMyEmailResponse501
) & {
  headers: Headers;
};

export type verifyMyEmailResponse = verifyMyEmailResponseSuccess | verifyMyEmailResponseError;

export const getVerifyMyEmailUrl = () => {
  return `/api/v1/users/me/emails/verify`;
};

/**
 * Completes the verification flow started by adding an email (or by /me/emails/resend). On success the address is marked verified and can be promoted to primary.
 * @summary Verify an email address with a one-time code
 */
export const verifyMyEmail = async (
  verifyMyEmailBody: VerifyMyEmailBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<verifyMyEmailResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<verifyMyEmailResponse>(getVerifyMyEmailUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(verifyMyEmailBody),
  });
};

export const getVerifyMyEmailMutationKey = () => ['verifyMyEmail'] as const;

export const getVerifyMyEmailMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyMyEmail>>,
    TError,
    VerifyMyEmailMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyMyEmail>>,
  TError,
  VerifyMyEmailMutationVariables,
  TContext
> => {
  const mutationKey = getVerifyMyEmailMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyMyEmail>>,
    VerifyMyEmailMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return verifyMyEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyMyEmailMutationResult = NonNullable<Awaited<ReturnType<typeof verifyMyEmail>>>;
export type VerifyMyEmailMutationBody = VerifyMyEmailBody;
export type VerifyMyEmailMutationError = ErrorResponse;
export type VerifyMyEmailMutationVariables = { data: VerifyMyEmailBody };

/**
 * @summary Verify an email address with a one-time code
 */
export const useVerifyMyEmail = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof verifyMyEmail>>,
      TError,
      VerifyMyEmailMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof verifyMyEmail>>,
  TError,
  VerifyMyEmailMutationVariables,
  TContext
> => {
  return useMutation(getVerifyMyEmailMutationOptions(options), queryClient);
};

export type listMyGroupsResponse200 = {
  data: ListMyGroupsResponse;
  status: 200;
};

export type listMyGroupsResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type listMyGroupsResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type listMyGroupsResponseSuccess = listMyGroupsResponse200 & {
  headers: Headers;
};
export type listMyGroupsResponseError = (listMyGroupsResponse401 | listMyGroupsResponse403) & {
  headers: Headers;
};

export type listMyGroupsResponse = listMyGroupsResponseSuccess | listMyGroupsResponseError;

export const getListMyGroupsUrl = (params?: ListMyGroupsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/users/me/groups?${stringifiedParams}`
    : `/api/v1/users/me/groups`;
};

/**
 * The groups the authenticated USER actor holds a role in, by name, with each one's parent (when the caller can see it), how many of its sub-groups the caller can see, and the caller's permissions there. A parent's Admin who holds no role in a sub-group finds it under the parent (`GET /api/v1/groups/{groupActorUuid}/sub-groups`), not here.
 * @summary List my groups
 */
export const listMyGroups = async (
  params?: ListMyGroupsParams,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<listMyGroupsResponse> => {
  return onearlyRequest<listMyGroupsResponse>(getListMyGroupsUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getListMyGroupsQueryKey = (params?: ListMyGroupsParams) => {
  return [`/api/v1/users/me/groups`, ...(params ? [params] : [])] as const;
};

export const getListMyGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMyGroups>>,
  TError = ErrorResponse,
>(
  params?: ListMyGroupsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyGroups>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMyGroupsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyGroups>>> = ({ signal }) =>
    listMyGroups(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMyGroups>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMyGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyGroups>>>;
export type ListMyGroupsQueryError = ErrorResponse;

export function useListMyGroups<
  TData = Awaited<ReturnType<typeof listMyGroups>>,
  TError = ErrorResponse,
>(
  params: undefined | ListMyGroupsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyGroups>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyGroups>>,
          TError,
          Awaited<ReturnType<typeof listMyGroups>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMyGroups<
  TData = Awaited<ReturnType<typeof listMyGroups>>,
  TError = ErrorResponse,
>(
  params?: ListMyGroupsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyGroups>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyGroups>>,
          TError,
          Awaited<ReturnType<typeof listMyGroups>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMyGroups<
  TData = Awaited<ReturnType<typeof listMyGroups>>,
  TError = ErrorResponse,
>(
  params?: ListMyGroupsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyGroups>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List my groups
 */

export function useListMyGroups<
  TData = Awaited<ReturnType<typeof listMyGroups>>,
  TError = ErrorResponse,
>(
  params?: ListMyGroupsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyGroups>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListMyGroupsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getMyNextActionResponse200 = {
  data: NextActionResponse;
  status: 200;
};

export type getMyNextActionResponse204 = {
  data: void;
  status: 204;
};

export type getMyNextActionResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type getMyNextActionResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type getMyNextActionResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type getMyNextActionResponseSuccess = (
  | getMyNextActionResponse200
  | getMyNextActionResponse204
) & {
  headers: Headers;
};
export type getMyNextActionResponseError = (
  | getMyNextActionResponse400
  | getMyNextActionResponse401
  | getMyNextActionResponse403
) & {
  headers: Headers;
};

export type getMyNextActionResponse = getMyNextActionResponseSuccess | getMyNextActionResponseError;

export const getGetMyNextActionUrl = (params?: GetMyNextActionParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/users/me/next-action?${stringifiedParams}`
    : `/api/v1/users/me/next-action`;
};

/**
 * Returns at most one item the authenticated USER actor should act on next, from the chosen driver. Only the caller's own appointments, tasks, shares and invites are considered.
 * @summary Get my next action
 */
export const getMyNextAction = async (
  params?: GetMyNextActionParams,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<getMyNextActionResponse> => {
  return onearlyRequest<getMyNextActionResponse>(getGetMyNextActionUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getGetMyNextActionQueryKey = (params?: GetMyNextActionParams) => {
  return [`/api/v1/users/me/next-action`, ...(params ? [params] : [])] as const;
};

export const getGetMyNextActionQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyNextAction>>,
  TError = ErrorResponse,
>(
  params?: GetMyNextActionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyNextAction>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyNextActionQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyNextAction>>> = ({ signal }) =>
    getMyNextAction(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyNextAction>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyNextActionQueryResult = NonNullable<Awaited<ReturnType<typeof getMyNextAction>>>;
export type GetMyNextActionQueryError = ErrorResponse;

export function useGetMyNextAction<
  TData = Awaited<ReturnType<typeof getMyNextAction>>,
  TError = ErrorResponse,
>(
  params: undefined | GetMyNextActionParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyNextAction>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyNextAction>>,
          TError,
          Awaited<ReturnType<typeof getMyNextAction>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyNextAction<
  TData = Awaited<ReturnType<typeof getMyNextAction>>,
  TError = ErrorResponse,
>(
  params?: GetMyNextActionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyNextAction>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyNextAction>>,
          TError,
          Awaited<ReturnType<typeof getMyNextAction>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyNextAction<
  TData = Awaited<ReturnType<typeof getMyNextAction>>,
  TError = ErrorResponse,
>(
  params?: GetMyNextActionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyNextAction>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get my next action
 */

export function useGetMyNextAction<
  TData = Awaited<ReturnType<typeof getMyNextAction>>,
  TError = ErrorResponse,
>(
  params?: GetMyNextActionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyNextAction>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyNextActionQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type listMyNotificationPreferencesResponse200 = {
  data: NotificationPreferenceListResponse;
  status: 200;
};

export type listMyNotificationPreferencesResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type listMyNotificationPreferencesResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type listMyNotificationPreferencesResponseSuccess =
  listMyNotificationPreferencesResponse200 & {
    headers: Headers;
  };
export type listMyNotificationPreferencesResponseError = (
  | listMyNotificationPreferencesResponse401
  | listMyNotificationPreferencesResponse403
) & {
  headers: Headers;
};

export type listMyNotificationPreferencesResponse =
  | listMyNotificationPreferencesResponseSuccess
  | listMyNotificationPreferencesResponseError;

export const getListMyNotificationPreferencesUrl = () => {
  return `/api/v1/users/me/notification-preferences`;
};

/**
 * Lists the authenticated USER actor's preference for every notification topic. Supported channels the user never configured default to enabled; unsupported channels are always reported disabled (see `supportedChannels`).
 * @summary List notification preferences
 */
export const listMyNotificationPreferences = async (
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<listMyNotificationPreferencesResponse> => {
  return onearlyRequest<listMyNotificationPreferencesResponse>(
    getListMyNotificationPreferencesUrl(),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getListMyNotificationPreferencesQueryKey = () => {
  return [`/api/v1/users/me/notification-preferences`] as const;
};

export const getListMyNotificationPreferencesQueryOptions = <
  TData = Awaited<ReturnType<typeof listMyNotificationPreferences>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listMyNotificationPreferences>>, TError, TData>
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMyNotificationPreferencesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyNotificationPreferences>>> = ({
    signal,
  }) => listMyNotificationPreferences({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMyNotificationPreferences>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMyNotificationPreferencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMyNotificationPreferences>>
>;
export type ListMyNotificationPreferencesQueryError = ErrorResponse;

export function useListMyNotificationPreferences<
  TData = Awaited<ReturnType<typeof listMyNotificationPreferences>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMyNotificationPreferences>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyNotificationPreferences>>,
          TError,
          Awaited<ReturnType<typeof listMyNotificationPreferences>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMyNotificationPreferences<
  TData = Awaited<ReturnType<typeof listMyNotificationPreferences>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMyNotificationPreferences>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyNotificationPreferences>>,
          TError,
          Awaited<ReturnType<typeof listMyNotificationPreferences>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMyNotificationPreferences<
  TData = Awaited<ReturnType<typeof listMyNotificationPreferences>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMyNotificationPreferences>>, TError, TData>
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List notification preferences
 */

export function useListMyNotificationPreferences<
  TData = Awaited<ReturnType<typeof listMyNotificationPreferences>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMyNotificationPreferences>>, TError, TData>
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListMyNotificationPreferencesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type updateMyNotificationPreferenceResponse200 = {
  data: NotificationPreferenceListResponse;
  status: 200;
};

export type updateMyNotificationPreferenceResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type updateMyNotificationPreferenceResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type updateMyNotificationPreferenceResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type updateMyNotificationPreferenceResponseSuccess =
  updateMyNotificationPreferenceResponse200 & {
    headers: Headers;
  };
export type updateMyNotificationPreferenceResponseError = (
  | updateMyNotificationPreferenceResponse400
  | updateMyNotificationPreferenceResponse401
  | updateMyNotificationPreferenceResponse403
) & {
  headers: Headers;
};

export type updateMyNotificationPreferenceResponse =
  | updateMyNotificationPreferenceResponseSuccess
  | updateMyNotificationPreferenceResponseError;

export const getUpdateMyNotificationPreferenceUrl = (topic: NotificationTopic) => {
  return `/api/v1/users/me/notification-preferences/${topic}`;
};

/**
 * Sets (upserts) the authenticated USER actor's push preference for one topic and returns the full updated preference list. Idempotent.
 * @summary Set a notification preference
 */
export const updateMyNotificationPreference = async (
  topic: NotificationTopic,
  updateNotificationPreferenceBody: UpdateNotificationPreferenceBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<updateMyNotificationPreferenceResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<updateMyNotificationPreferenceResponse>(
    getUpdateMyNotificationPreferenceUrl(topic),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
      body: JSON.stringify(updateNotificationPreferenceBody),
    },
  );
};

export const getUpdateMyNotificationPreferenceMutationKey = () =>
  ['updateMyNotificationPreference'] as const;

export const getUpdateMyNotificationPreferenceMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyNotificationPreference>>,
    TError,
    UpdateMyNotificationPreferenceMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyNotificationPreference>>,
  TError,
  UpdateMyNotificationPreferenceMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateMyNotificationPreferenceMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyNotificationPreference>>,
    UpdateMyNotificationPreferenceMutationVariables
  > = (props) => {
    const { topic, data } = props ?? {};

    return updateMyNotificationPreference(topic, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMyNotificationPreferenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMyNotificationPreference>>
>;
export type UpdateMyNotificationPreferenceMutationBody = UpdateNotificationPreferenceBody;
export type UpdateMyNotificationPreferenceMutationError = ErrorResponse;
export type UpdateMyNotificationPreferenceMutationVariables = {
  topic: NotificationTopic;
  data: UpdateNotificationPreferenceBody;
};

/**
 * @summary Set a notification preference
 */
export const useUpdateMyNotificationPreference = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMyNotificationPreference>>,
      TError,
      UpdateMyNotificationPreferenceMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMyNotificationPreference>>,
  TError,
  UpdateMyNotificationPreferenceMutationVariables,
  TContext
> => {
  return useMutation(getUpdateMyNotificationPreferenceMutationOptions(options), queryClient);
};

export type getMyNotificationSettingsResponse200 = {
  data: NotificationSettingsResponse;
  status: 200;
};

export type getMyNotificationSettingsResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type getMyNotificationSettingsResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type getMyNotificationSettingsResponseSuccess = getMyNotificationSettingsResponse200 & {
  headers: Headers;
};
export type getMyNotificationSettingsResponseError = (
  | getMyNotificationSettingsResponse401
  | getMyNotificationSettingsResponse403
) & {
  headers: Headers;
};

export type getMyNotificationSettingsResponse =
  | getMyNotificationSettingsResponseSuccess
  | getMyNotificationSettingsResponseError;

export const getGetMyNotificationSettingsUrl = () => {
  return `/api/v1/users/me/notification-settings`;
};

/**
 * The authenticated USER actor's notification rendering settings (message previews). Users who never set them get the defaults — previews hidden.
 * @summary Get notification settings
 */
export const getMyNotificationSettings = async (
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<getMyNotificationSettingsResponse> => {
  return onearlyRequest<getMyNotificationSettingsResponse>(getGetMyNotificationSettingsUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getGetMyNotificationSettingsQueryKey = () => {
  return [`/api/v1/users/me/notification-settings`] as const;
};

export const getGetMyNotificationSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyNotificationSettings>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMyNotificationSettings>>, TError, TData>
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyNotificationSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyNotificationSettings>>> = ({
    signal,
  }) => getMyNotificationSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyNotificationSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyNotificationSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyNotificationSettings>>
>;
export type GetMyNotificationSettingsQueryError = ErrorResponse;

export function useGetMyNotificationSettings<
  TData = Awaited<ReturnType<typeof getMyNotificationSettings>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyNotificationSettings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyNotificationSettings>>,
          TError,
          Awaited<ReturnType<typeof getMyNotificationSettings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyNotificationSettings<
  TData = Awaited<ReturnType<typeof getMyNotificationSettings>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyNotificationSettings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyNotificationSettings>>,
          TError,
          Awaited<ReturnType<typeof getMyNotificationSettings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyNotificationSettings<
  TData = Awaited<ReturnType<typeof getMyNotificationSettings>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyNotificationSettings>>, TError, TData>
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get notification settings
 */

export function useGetMyNotificationSettings<
  TData = Awaited<ReturnType<typeof getMyNotificationSettings>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyNotificationSettings>>, TError, TData>
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyNotificationSettingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type updateMyNotificationSettingsResponse200 = {
  data: NotificationSettingsResponse;
  status: 200;
};

export type updateMyNotificationSettingsResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type updateMyNotificationSettingsResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type updateMyNotificationSettingsResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type updateMyNotificationSettingsResponseSuccess =
  updateMyNotificationSettingsResponse200 & {
    headers: Headers;
  };
export type updateMyNotificationSettingsResponseError = (
  | updateMyNotificationSettingsResponse400
  | updateMyNotificationSettingsResponse401
  | updateMyNotificationSettingsResponse403
) & {
  headers: Headers;
};

export type updateMyNotificationSettingsResponse =
  | updateMyNotificationSettingsResponseSuccess
  | updateMyNotificationSettingsResponseError;

export const getUpdateMyNotificationSettingsUrl = () => {
  return `/api/v1/users/me/notification-settings`;
};

/**
 * Sets (upserts) the authenticated USER actor's notification rendering settings and returns the updated settings. Idempotent.
 * @summary Set notification settings
 */
export const updateMyNotificationSettings = async (
  updateNotificationSettingsBody: UpdateNotificationSettingsBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<updateMyNotificationSettingsResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<updateMyNotificationSettingsResponse>(
    getUpdateMyNotificationSettingsUrl(),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
      body: JSON.stringify(updateNotificationSettingsBody),
    },
  );
};

export const getUpdateMyNotificationSettingsMutationKey = () =>
  ['updateMyNotificationSettings'] as const;

export const getUpdateMyNotificationSettingsMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyNotificationSettings>>,
    TError,
    UpdateMyNotificationSettingsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyNotificationSettings>>,
  TError,
  UpdateMyNotificationSettingsMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateMyNotificationSettingsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyNotificationSettings>>,
    UpdateMyNotificationSettingsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return updateMyNotificationSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMyNotificationSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMyNotificationSettings>>
>;
export type UpdateMyNotificationSettingsMutationBody = UpdateNotificationSettingsBody;
export type UpdateMyNotificationSettingsMutationError = ErrorResponse;
export type UpdateMyNotificationSettingsMutationVariables = {
  data: UpdateNotificationSettingsBody;
};

/**
 * @summary Set notification settings
 */
export const useUpdateMyNotificationSettings = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMyNotificationSettings>>,
      TError,
      UpdateMyNotificationSettingsMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMyNotificationSettings>>,
  TError,
  UpdateMyNotificationSettingsMutationVariables,
  TContext
> => {
  return useMutation(getUpdateMyNotificationSettingsMutationOptions(options), queryClient);
};

export type listMyPhonesResponse200 = {
  data: MyPhonesResponse;
  status: 200;
};

export type listMyPhonesResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type listMyPhonesResponse501 = {
  data: ErrorResponse;
  status: 501;
};

export type listMyPhonesResponseSuccess = listMyPhonesResponse200 & {
  headers: Headers;
};
export type listMyPhonesResponseError = (listMyPhonesResponse401 | listMyPhonesResponse501) & {
  headers: Headers;
};

export type listMyPhonesResponse = listMyPhonesResponseSuccess | listMyPhonesResponseError;

export const getListMyPhonesUrl = () => {
  return `/api/v1/users/me/phones`;
};

/**
 * Returns every phone number on the authenticated account — the primary plus any secondaries — with per-number verification state.
 * @summary List my phone numbers
 */
export const listMyPhones = async (
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<listMyPhonesResponse> => {
  return onearlyRequest<listMyPhonesResponse>(getListMyPhonesUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getListMyPhonesQueryKey = () => {
  return [`/api/v1/users/me/phones`] as const;
};

export const getListMyPhonesQueryOptions = <
  TData = Awaited<ReturnType<typeof listMyPhones>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyPhones>>, TError, TData>>;
  request?: SecondParameter<typeof onearlyRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMyPhonesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyPhones>>> = ({ signal }) =>
    listMyPhones({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMyPhones>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMyPhonesQueryResult = NonNullable<Awaited<ReturnType<typeof listMyPhones>>>;
export type ListMyPhonesQueryError = ErrorResponse;

export function useListMyPhones<
  TData = Awaited<ReturnType<typeof listMyPhones>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyPhones>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyPhones>>,
          TError,
          Awaited<ReturnType<typeof listMyPhones>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMyPhones<
  TData = Awaited<ReturnType<typeof listMyPhones>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyPhones>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyPhones>>,
          TError,
          Awaited<ReturnType<typeof listMyPhones>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMyPhones<
  TData = Awaited<ReturnType<typeof listMyPhones>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyPhones>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List my phone numbers
 */

export function useListMyPhones<
  TData = Awaited<ReturnType<typeof listMyPhones>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyPhones>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListMyPhonesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type addMyPhoneResponse200 = {
  data: AddMyPhoneResponse;
  status: 200;
};

export type addMyPhoneResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type addMyPhoneResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type addMyPhoneResponse409 = {
  data: ErrorResponse;
  status: 409;
};

export type addMyPhoneResponse501 = {
  data: ErrorResponse;
  status: 501;
};

export type addMyPhoneResponseSuccess = addMyPhoneResponse200 & {
  headers: Headers;
};
export type addMyPhoneResponseError = (
  | addMyPhoneResponse400
  | addMyPhoneResponse401
  | addMyPhoneResponse409
  | addMyPhoneResponse501
) & {
  headers: Headers;
};

export type addMyPhoneResponse = addMyPhoneResponseSuccess | addMyPhoneResponseError;

export const getAddMyPhoneUrl = () => {
  return `/api/v1/users/me/phones`;
};

/**
 * Adds a secondary phone number to the account (unverified) and sends a one-time verification code to it by SMS. Echo the returned verification state back on /me/phones/verify with the code.
 * @summary Add a secondary phone number
 */
export const addMyPhone = async (
  addMyPhoneBody: AddMyPhoneBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<addMyPhoneResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<addMyPhoneResponse>(getAddMyPhoneUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addMyPhoneBody),
  });
};

export const getAddMyPhoneMutationKey = () => ['addMyPhone'] as const;

export const getAddMyPhoneMutationOptions = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addMyPhone>>,
    TError,
    AddMyPhoneMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addMyPhone>>,
  TError,
  AddMyPhoneMutationVariables,
  TContext
> => {
  const mutationKey = getAddMyPhoneMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addMyPhone>>,
    AddMyPhoneMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return addMyPhone(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddMyPhoneMutationResult = NonNullable<Awaited<ReturnType<typeof addMyPhone>>>;
export type AddMyPhoneMutationBody = AddMyPhoneBody;
export type AddMyPhoneMutationError = ErrorResponse;
export type AddMyPhoneMutationVariables = { data: AddMyPhoneBody };

/**
 * @summary Add a secondary phone number
 */
export const useAddMyPhone = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addMyPhone>>,
      TError,
      AddMyPhoneMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addMyPhone>>,
  TError,
  AddMyPhoneMutationVariables,
  TContext
> => {
  return useMutation(getAddMyPhoneMutationOptions(options), queryClient);
};

export type setPrimaryPhoneResponse200 = {
  data: MyPhonesResponse;
  status: 200;
};

export type setPrimaryPhoneResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type setPrimaryPhoneResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type setPrimaryPhoneResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type setPrimaryPhoneResponse501 = {
  data: ErrorResponse;
  status: 501;
};

export type setPrimaryPhoneResponseSuccess = setPrimaryPhoneResponse200 & {
  headers: Headers;
};
export type setPrimaryPhoneResponseError = (
  | setPrimaryPhoneResponse400
  | setPrimaryPhoneResponse401
  | setPrimaryPhoneResponse404
  | setPrimaryPhoneResponse501
) & {
  headers: Headers;
};

export type setPrimaryPhoneResponse = setPrimaryPhoneResponseSuccess | setPrimaryPhoneResponseError;

export const getSetPrimaryPhoneUrl = () => {
  return `/api/v1/users/me/phones/primary`;
};

/**
 * Promotes a VERIFIED secondary phone number to primary. The previous primary becomes a secondary (still verified, still usable for login).
 * @summary Make a verified phone number the primary
 */
export const setPrimaryPhone = async (
  setPrimaryPhoneBody: SetPrimaryPhoneBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<setPrimaryPhoneResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<setPrimaryPhoneResponse>(getSetPrimaryPhoneUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setPrimaryPhoneBody),
  });
};

export const getSetPrimaryPhoneMutationKey = () => ['setPrimaryPhone'] as const;

export const getSetPrimaryPhoneMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setPrimaryPhone>>,
    TError,
    SetPrimaryPhoneMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setPrimaryPhone>>,
  TError,
  SetPrimaryPhoneMutationVariables,
  TContext
> => {
  const mutationKey = getSetPrimaryPhoneMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setPrimaryPhone>>,
    SetPrimaryPhoneMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return setPrimaryPhone(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetPrimaryPhoneMutationResult = NonNullable<
  Awaited<ReturnType<typeof setPrimaryPhone>>
>;
export type SetPrimaryPhoneMutationBody = SetPrimaryPhoneBody;
export type SetPrimaryPhoneMutationError = ErrorResponse;
export type SetPrimaryPhoneMutationVariables = { data: SetPrimaryPhoneBody };

/**
 * @summary Make a verified phone number the primary
 */
export const useSetPrimaryPhone = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setPrimaryPhone>>,
      TError,
      SetPrimaryPhoneMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setPrimaryPhone>>,
  TError,
  SetPrimaryPhoneMutationVariables,
  TContext
> => {
  return useMutation(getSetPrimaryPhoneMutationOptions(options), queryClient);
};

export type removeMyPhoneResponse200 = {
  data: MyPhonesResponse;
  status: 200;
};

export type removeMyPhoneResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type removeMyPhoneResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type removeMyPhoneResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type removeMyPhoneResponse501 = {
  data: ErrorResponse;
  status: 501;
};

export type removeMyPhoneResponseSuccess = removeMyPhoneResponse200 & {
  headers: Headers;
};
export type removeMyPhoneResponseError = (
  | removeMyPhoneResponse400
  | removeMyPhoneResponse401
  | removeMyPhoneResponse404
  | removeMyPhoneResponse501
) & {
  headers: Headers;
};

export type removeMyPhoneResponse = removeMyPhoneResponseSuccess | removeMyPhoneResponseError;

export const getRemoveMyPhoneUrl = () => {
  return `/api/v1/users/me/phones/remove`;
};

/**
 * Removes a secondary phone number from the account. The primary cannot be removed — promote another number first.
 * @summary Remove a secondary phone number
 */
export const removeMyPhone = async (
  removeMyPhoneBody: RemoveMyPhoneBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<removeMyPhoneResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<removeMyPhoneResponse>(getRemoveMyPhoneUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(removeMyPhoneBody),
  });
};

export const getRemoveMyPhoneMutationKey = () => ['removeMyPhone'] as const;

export const getRemoveMyPhoneMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeMyPhone>>,
    TError,
    RemoveMyPhoneMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeMyPhone>>,
  TError,
  RemoveMyPhoneMutationVariables,
  TContext
> => {
  const mutationKey = getRemoveMyPhoneMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeMyPhone>>,
    RemoveMyPhoneMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return removeMyPhone(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveMyPhoneMutationResult = NonNullable<Awaited<ReturnType<typeof removeMyPhone>>>;
export type RemoveMyPhoneMutationBody = RemoveMyPhoneBody;
export type RemoveMyPhoneMutationError = ErrorResponse;
export type RemoveMyPhoneMutationVariables = { data: RemoveMyPhoneBody };

/**
 * @summary Remove a secondary phone number
 */
export const useRemoveMyPhone = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeMyPhone>>,
      TError,
      RemoveMyPhoneMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeMyPhone>>,
  TError,
  RemoveMyPhoneMutationVariables,
  TContext
> => {
  return useMutation(getRemoveMyPhoneMutationOptions(options), queryClient);
};

export type resendMyPhoneCodeResponse200 = {
  data: ResendMyPhoneCodeResponse;
  status: 200;
};

export type resendMyPhoneCodeResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type resendMyPhoneCodeResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type resendMyPhoneCodeResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type resendMyPhoneCodeResponse501 = {
  data: ErrorResponse;
  status: 501;
};

export type resendMyPhoneCodeResponseSuccess = resendMyPhoneCodeResponse200 & {
  headers: Headers;
};
export type resendMyPhoneCodeResponseError = (
  | resendMyPhoneCodeResponse400
  | resendMyPhoneCodeResponse401
  | resendMyPhoneCodeResponse404
  | resendMyPhoneCodeResponse501
) & {
  headers: Headers;
};

export type resendMyPhoneCodeResponse =
  | resendMyPhoneCodeResponseSuccess
  | resendMyPhoneCodeResponseError;

export const getResendMyPhoneCodeUrl = () => {
  return `/api/v1/users/me/phones/resend`;
};

/**
 * Starts a fresh verification flow for a number already on the account, invalidating any previously sent code.
 * @summary Re-send the verification code for a phone number
 */
export const resendMyPhoneCode = async (
  resendMyPhoneCodeBody: ResendMyPhoneCodeBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<resendMyPhoneCodeResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<resendMyPhoneCodeResponse>(getResendMyPhoneCodeUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(resendMyPhoneCodeBody),
  });
};

export const getResendMyPhoneCodeMutationKey = () => ['resendMyPhoneCode'] as const;

export const getResendMyPhoneCodeMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendMyPhoneCode>>,
    TError,
    ResendMyPhoneCodeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendMyPhoneCode>>,
  TError,
  ResendMyPhoneCodeMutationVariables,
  TContext
> => {
  const mutationKey = getResendMyPhoneCodeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendMyPhoneCode>>,
    ResendMyPhoneCodeMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return resendMyPhoneCode(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendMyPhoneCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendMyPhoneCode>>
>;
export type ResendMyPhoneCodeMutationBody = ResendMyPhoneCodeBody;
export type ResendMyPhoneCodeMutationError = ErrorResponse;
export type ResendMyPhoneCodeMutationVariables = { data: ResendMyPhoneCodeBody };

/**
 * @summary Re-send the verification code for a phone number
 */
export const useResendMyPhoneCode = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resendMyPhoneCode>>,
      TError,
      ResendMyPhoneCodeMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resendMyPhoneCode>>,
  TError,
  ResendMyPhoneCodeMutationVariables,
  TContext
> => {
  return useMutation(getResendMyPhoneCodeMutationOptions(options), queryClient);
};

export type verifyMyPhoneResponse200 = {
  data: VerifyMyPhoneResponse;
  status: 200;
};

export type verifyMyPhoneResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type verifyMyPhoneResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type verifyMyPhoneResponse409 = {
  data: ErrorResponse;
  status: 409;
};

export type verifyMyPhoneResponse501 = {
  data: ErrorResponse;
  status: 501;
};

export type verifyMyPhoneResponseSuccess = verifyMyPhoneResponse200 & {
  headers: Headers;
};
export type verifyMyPhoneResponseError = (
  | verifyMyPhoneResponse400
  | verifyMyPhoneResponse401
  | verifyMyPhoneResponse409
  | verifyMyPhoneResponse501
) & {
  headers: Headers;
};

export type verifyMyPhoneResponse = verifyMyPhoneResponseSuccess | verifyMyPhoneResponseError;

export const getVerifyMyPhoneUrl = () => {
  return `/api/v1/users/me/phones/verify`;
};

/**
 * Completes the verification flow started by adding a phone number (or by /me/phones/resend). On success the number is marked verified and can be promoted to primary.
 * @summary Verify a phone number with a one-time code
 */
export const verifyMyPhone = async (
  verifyMyPhoneBody: VerifyMyPhoneBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<verifyMyPhoneResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<verifyMyPhoneResponse>(getVerifyMyPhoneUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(verifyMyPhoneBody),
  });
};

export const getVerifyMyPhoneMutationKey = () => ['verifyMyPhone'] as const;

export const getVerifyMyPhoneMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyMyPhone>>,
    TError,
    VerifyMyPhoneMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyMyPhone>>,
  TError,
  VerifyMyPhoneMutationVariables,
  TContext
> => {
  const mutationKey = getVerifyMyPhoneMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyMyPhone>>,
    VerifyMyPhoneMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return verifyMyPhone(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyMyPhoneMutationResult = NonNullable<Awaited<ReturnType<typeof verifyMyPhone>>>;
export type VerifyMyPhoneMutationBody = VerifyMyPhoneBody;
export type VerifyMyPhoneMutationError = ErrorResponse;
export type VerifyMyPhoneMutationVariables = { data: VerifyMyPhoneBody };

/**
 * @summary Verify a phone number with a one-time code
 */
export const useVerifyMyPhone = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof verifyMyPhone>>,
      TError,
      VerifyMyPhoneMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof verifyMyPhone>>,
  TError,
  VerifyMyPhoneMutationVariables,
  TContext
> => {
  return useMutation(getVerifyMyPhoneMutationOptions(options), queryClient);
};

export type getMyPinnedGroupsResponse200 = {
  data: PinnedGroupsResponse;
  status: 200;
};

export type getMyPinnedGroupsResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type getMyPinnedGroupsResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type getMyPinnedGroupsResponseSuccess = getMyPinnedGroupsResponse200 & {
  headers: Headers;
};
export type getMyPinnedGroupsResponseError = (
  | getMyPinnedGroupsResponse401
  | getMyPinnedGroupsResponse403
) & {
  headers: Headers;
};

export type getMyPinnedGroupsResponse =
  | getMyPinnedGroupsResponseSuccess
  | getMyPinnedGroupsResponseError;

export const getGetMyPinnedGroupsUrl = () => {
  return `/api/v1/users/me/pinned-groups`;
};

/**
 * The groups the authenticated USER actor pins to the desktop group rail, in rail order, on any device. Groups they have since left are left out. `groupUuids` is null for a user who has never chosen, so the app can apply its own default.
 * @summary Get pinned groups
 */
export const getMyPinnedGroups = async (
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<getMyPinnedGroupsResponse> => {
  return onearlyRequest<getMyPinnedGroupsResponse>(getGetMyPinnedGroupsUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getGetMyPinnedGroupsQueryKey = () => {
  return [`/api/v1/users/me/pinned-groups`] as const;
};

export const getGetMyPinnedGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyPinnedGroups>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyPinnedGroups>>, TError, TData>>;
  request?: SecondParameter<typeof onearlyRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyPinnedGroupsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyPinnedGroups>>> = ({ signal }) =>
    getMyPinnedGroups({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyPinnedGroups>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyPinnedGroupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyPinnedGroups>>
>;
export type GetMyPinnedGroupsQueryError = ErrorResponse;

export function useGetMyPinnedGroups<
  TData = Awaited<ReturnType<typeof getMyPinnedGroups>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyPinnedGroups>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyPinnedGroups>>,
          TError,
          Awaited<ReturnType<typeof getMyPinnedGroups>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyPinnedGroups<
  TData = Awaited<ReturnType<typeof getMyPinnedGroups>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyPinnedGroups>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyPinnedGroups>>,
          TError,
          Awaited<ReturnType<typeof getMyPinnedGroups>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyPinnedGroups<
  TData = Awaited<ReturnType<typeof getMyPinnedGroups>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyPinnedGroups>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get pinned groups
 */

export function useGetMyPinnedGroups<
  TData = Awaited<ReturnType<typeof getMyPinnedGroups>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyPinnedGroups>>, TError, TData>>;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyPinnedGroupsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type setMyPinnedGroupsResponse200 = {
  data: PinnedGroupsResponse;
  status: 200;
};

export type setMyPinnedGroupsResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type setMyPinnedGroupsResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type setMyPinnedGroupsResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type setMyPinnedGroupsResponseSuccess = setMyPinnedGroupsResponse200 & {
  headers: Headers;
};
export type setMyPinnedGroupsResponseError = (
  | setMyPinnedGroupsResponse400
  | setMyPinnedGroupsResponse401
  | setMyPinnedGroupsResponse403
) & {
  headers: Headers;
};

export type setMyPinnedGroupsResponse =
  | setMyPinnedGroupsResponseSuccess
  | setMyPinnedGroupsResponseError;

export const getSetMyPinnedGroupsUrl = () => {
  return `/api/v1/users/me/pinned-groups`;
};

/**
 * Replaces the authenticated USER actor's pinned groups with the given list, in its order, and returns the list as saved. Groups the user isn't in are left out rather than refused. Idempotent.
 * @summary Set pinned groups
 */
export const setMyPinnedGroups = async (
  setPinnedGroupsBody: SetPinnedGroupsBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<setMyPinnedGroupsResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<setMyPinnedGroupsResponse>(getSetMyPinnedGroupsUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setPinnedGroupsBody),
  });
};

export const getSetMyPinnedGroupsMutationKey = () => ['setMyPinnedGroups'] as const;

export const getSetMyPinnedGroupsMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setMyPinnedGroups>>,
    TError,
    SetMyPinnedGroupsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setMyPinnedGroups>>,
  TError,
  SetMyPinnedGroupsMutationVariables,
  TContext
> => {
  const mutationKey = getSetMyPinnedGroupsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setMyPinnedGroups>>,
    SetMyPinnedGroupsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return setMyPinnedGroups(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetMyPinnedGroupsMutationResult = NonNullable<
  Awaited<ReturnType<typeof setMyPinnedGroups>>
>;
export type SetMyPinnedGroupsMutationBody = SetPinnedGroupsBody;
export type SetMyPinnedGroupsMutationError = ErrorResponse;
export type SetMyPinnedGroupsMutationVariables = { data: SetPinnedGroupsBody };

/**
 * @summary Set pinned groups
 */
export const useSetMyPinnedGroups = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setMyPinnedGroups>>,
      TError,
      SetMyPinnedGroupsMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setMyPinnedGroups>>,
  TError,
  SetMyPinnedGroupsMutationVariables,
  TContext
> => {
  return useMutation(getSetMyPinnedGroupsMutationOptions(options), queryClient);
};

export type getMyVoicePreferencesResponse200 = {
  data: VoicePreferencesResponse;
  status: 200;
};

export type getMyVoicePreferencesResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type getMyVoicePreferencesResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type getMyVoicePreferencesResponseSuccess = getMyVoicePreferencesResponse200 & {
  headers: Headers;
};
export type getMyVoicePreferencesResponseError = (
  | getMyVoicePreferencesResponse401
  | getMyVoicePreferencesResponse403
) & {
  headers: Headers;
};

export type getMyVoicePreferencesResponse =
  | getMyVoicePreferencesResponseSuccess
  | getMyVoicePreferencesResponseError;

export const getGetMyVoicePreferencesUrl = () => {
  return `/api/v1/users/me/voice-preferences`;
};

/**
 * The authenticated USER actor's voice agent preferences. Users who never set them get the defaults — normal speech speed.
 * @summary Get voice preferences
 */
export const getMyVoicePreferences = async (
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<getMyVoicePreferencesResponse> => {
  return onearlyRequest<getMyVoicePreferencesResponse>(getGetMyVoicePreferencesUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getGetMyVoicePreferencesQueryKey = () => {
  return [`/api/v1/users/me/voice-preferences`] as const;
};

export const getGetMyVoicePreferencesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyVoicePreferences>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMyVoicePreferences>>, TError, TData>
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyVoicePreferencesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyVoicePreferences>>> = ({ signal }) =>
    getMyVoicePreferences({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyVoicePreferences>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyVoicePreferencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyVoicePreferences>>
>;
export type GetMyVoicePreferencesQueryError = ErrorResponse;

export function useGetMyVoicePreferences<
  TData = Awaited<ReturnType<typeof getMyVoicePreferences>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyVoicePreferences>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyVoicePreferences>>,
          TError,
          Awaited<ReturnType<typeof getMyVoicePreferences>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyVoicePreferences<
  TData = Awaited<ReturnType<typeof getMyVoicePreferences>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyVoicePreferences>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyVoicePreferences>>,
          TError,
          Awaited<ReturnType<typeof getMyVoicePreferences>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyVoicePreferences<
  TData = Awaited<ReturnType<typeof getMyVoicePreferences>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyVoicePreferences>>, TError, TData>
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get voice preferences
 */

export function useGetMyVoicePreferences<
  TData = Awaited<ReturnType<typeof getMyVoicePreferences>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyVoicePreferences>>, TError, TData>
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyVoicePreferencesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type updateMyVoicePreferencesResponse200 = {
  data: VoicePreferencesResponse;
  status: 200;
};

export type updateMyVoicePreferencesResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type updateMyVoicePreferencesResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type updateMyVoicePreferencesResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type updateMyVoicePreferencesResponseSuccess = updateMyVoicePreferencesResponse200 & {
  headers: Headers;
};
export type updateMyVoicePreferencesResponseError = (
  | updateMyVoicePreferencesResponse400
  | updateMyVoicePreferencesResponse401
  | updateMyVoicePreferencesResponse403
) & {
  headers: Headers;
};

export type updateMyVoicePreferencesResponse =
  | updateMyVoicePreferencesResponseSuccess
  | updateMyVoicePreferencesResponseError;

export const getUpdateMyVoicePreferencesUrl = () => {
  return `/api/v1/users/me/voice-preferences`;
};

/**
 * Updates the authenticated USER actor's voice agent preferences and returns them. Omitted fields keep their stored value. Idempotent.
 * @summary Update voice preferences
 */
export const updateMyVoicePreferences = async (
  updateVoicePreferencesBody: UpdateVoicePreferencesBody,
  options?: Parameters<typeof onearlyRequest>[1],
): Promise<updateMyVoicePreferencesResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return onearlyRequest<updateMyVoicePreferencesResponse>(getUpdateMyVoicePreferencesUrl(), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateVoicePreferencesBody),
  });
};

export const getUpdateMyVoicePreferencesMutationKey = () => ['updateMyVoicePreferences'] as const;

export const getUpdateMyVoicePreferencesMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyVoicePreferences>>,
    TError,
    UpdateMyVoicePreferencesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof onearlyRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyVoicePreferences>>,
  TError,
  UpdateMyVoicePreferencesMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateMyVoicePreferencesMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyVoicePreferences>>,
    UpdateMyVoicePreferencesMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return updateMyVoicePreferences(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMyVoicePreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMyVoicePreferences>>
>;
export type UpdateMyVoicePreferencesMutationBody = UpdateVoicePreferencesBody;
export type UpdateMyVoicePreferencesMutationError = ErrorResponse;
export type UpdateMyVoicePreferencesMutationVariables = { data: UpdateVoicePreferencesBody };

/**
 * @summary Update voice preferences
 */
export const useUpdateMyVoicePreferences = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMyVoicePreferences>>,
      TError,
      UpdateMyVoicePreferencesMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof onearlyRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMyVoicePreferences>>,
  TError,
  UpdateMyVoicePreferencesMutationVariables,
  TContext
> => {
  return useMutation(getUpdateMyVoicePreferencesMutationOptions(options), queryClient);
};
